// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========================================================================
   Edu — 강의 영역
   사이드바·인트로 공통 스타일은 Prompt.css 재사용
   ======================================================================== */

/* 사이드바 — 새 강의 / 강의 타임라인 추가 강조 박스 (Figma) */
.edu-sidebar__new {
  background: var(--fg-bg-mychat);
  font-weight: 600;
}

.edu-sidebar__new:hover {
  background: #d8dbed;
}

.edu-sidebar__new--active {
  background: #fff;
  font-weight: 600;
}

.edu-sidebar__timeline {
  background: #cae6e5;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.edu-sidebar__timeline:hover {
  background: #b8dcdb;
}

.edu-sidebar__timeline--active {
  background: #fff;
  font-weight: 600;
}

.edu-sidebar__spacer {
  display: block;
  height: 20px;
}

/* ─────────────────────────────────────────────
   사이드바 접힘 상태 (Figma 2030:14844 — sidebar closed)
   너비 64px · 아이콘만 노출 · 32x32 버튼
   ───────────────────────────────────────────── */
.edu-sidebar--collapsed {
  width: 64px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  padding: 30px 16px;
  background: var(--fg-bg-content);
  border-top-left-radius: 16px;
  overflow: hidden;
  transition:
    width 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    padding 0.28s cubic-bezier(0.4, 0, 0.2, 1),
    gap 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.edu-sidebar--collapsed>* {
  animation: eduSidebarFadeIn 0.24s ease both;
}

@keyframes eduSidebarFadeIn {
  from {
    opacity: 0;
    transform: translateY(2px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.edu-sidebar__collapsed-nav {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.edu-sidebar__icon-btn {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
  padding: 0;
}

.edu-sidebar__icon-btn:hover {
  background: rgba(0, 0, 0, 0.04);
}

.edu-sidebar__icon-btn--active {
  background: #fff;
}

.edu-sidebar__icon-btn--toggle {
  color: var(--fg-text-basic);
}

.edu-sidebar__icon-btn--new {
  background: var(--fg-bg-mychat);
}

.edu-sidebar__icon-btn--new:hover {
  background: #d8dbed;
}

.edu-sidebar__icon-btn--new.edu-sidebar__icon-btn--active {
  background: #fff;
}

.edu-sidebar__icon-btn--timeline {
  background: #cae6e5;
}

.edu-sidebar__icon-btn--timeline:hover {
  background: #b8dcdb;
}

.edu-sidebar__icon-btn--timeline.edu-sidebar__icon-btn--active {
  background: #fff;
}

/* 통계/생성 버튼 행 */
.edu-list__top-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.edu-list__stats {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* 탭 + 우측 컨트롤 */
.edu-list__tab-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  /* border-bottom: 1px solid var(--fg-line); */
  flex-wrap: wrap;
}

.edu-list__tabs {
  display: flex;
}

.edu-list__tab {
  padding: 12px 16px;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  margin-bottom: -1px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.edu-list__tab span {
  margin-left: 4px;
  color: var(--fg-text-gray);
  font-size: 13px;
}

.edu-list__tab:hover {
  color: var(--fg-button-hover);
}

.edu-list__tab--active {
  border-bottom-color: var(--fg-text-basic);
  color: var(--fg-text-basic);
  font-weight: 600;
}

.edu-list__tab-right {
  display: flex;
  align-items: center;
  gap: 8px;
  /* padding-bottom: 8px; */
}

/* 테이블 */
.edu-list__table-wrap {
  width: 100%;
  overflow-x: auto;
}

.edu-list__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.edu-list__table thead th {
  padding: 20px;
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  color: var(--fg-text-basic);
  border-bottom: 1px solid var(--fg-text-basic);
  white-space: nowrap;
  background: transparent;
}

/* Figma 2073:21154 — 컬럼별 폭 (헤더+바디 동시 적용) */
.edu-list__table th:nth-child(1),
.edu-list__table td:nth-child(1) {
  width: 75px;
  text-align: center;
}

.edu-list__table th:nth-child(3),
.edu-list__table td:nth-child(3) {
  width: 80px;
  text-align: center;
}

.edu-list__table th:nth-child(4),
.edu-list__table td:nth-child(4) {
  width: 160px;
  text-align: center;
}

.edu-list__table th:nth-child(5),
.edu-list__table td:nth-child(5) {
  width: 90px;
  text-align: center;
}

.edu-list__table th:nth-child(6),
.edu-list__table td:nth-child(6) {
  width: 90px;
  text-align: center;
}

.edu-list__table th:nth-child(7),
.edu-list__table td:nth-child(7) {
  width: 100px;
  text-align: center;
}

.edu-list__table tbody tr {
  cursor: pointer;
  transition: var(--transition-fast);
}

.edu-list__table tbody tr:hover {
  background: var(--fg-bg-card);
}

.edu-list__table tbody td {
  padding: 16px;
  vertical-align: top;
  border-bottom: 1px solid var(--fg-line);
  color: var(--fg-text-basic);
  vertical-align: middle;
}

.edu-list__cell-light {
  color: var(--fg-text-gray);
  white-space: nowrap;
  font-size: 14px;
  font-weight: 500;
}

.edu-list__price {
  color: var(--fg-side-hover);
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  text-align: right;
  width: 90px;
}

.edu-list__price b {
  font-weight: 700;
}

.edu-list__price small {
  margin-left: 4px;
  font-size: 14px;
  font-weight: 500;
}

.edu-list__cell-members {
  color: var(--fg-text-basic);
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  text-align: right;
  width: 90px;
}

.edu-list__cell-members b {
  font-weight: 700;
}

.edu-list__cell-members span {
  color: var(--fg-text-gray);
  font-weight: 500;
}

/* 상태 pill — Figma 색상 매핑 */
.edu-list__status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.edu-list__status-dot {
  width: 10px;
  height: 10px;
  border-radius: 9999px;
  background: currentColor;
}

.edu-list__status--enrolled {
  background: #daffd7;
  color: #3cb832;
}

.edu-list__status--open {
  background: #d0f8ff;
  color: #3cb6ca;
}

.edu-list__status--mine {
  background: #ffe4b8;
  color: #ea5440;
}

.edu-list__status--ended {
  background: #f2f2f2;
  color: #8c8c8c;
}

/* 제목 셀 */
.edu-list__title-cell {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  max-width: 520px;
}

.edu-list__tag {
  flex-shrink: 0;
  padding: 3px 10px;
  border: 1px solid var(--fg-text-basic);
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  color: var(--fg-text-basic);
  white-space: nowrap;
  line-height: 18px;
}

.edu-list__title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
  line-height: 20px;
}

.edu-list__summary {
  margin: 4px 0 0;
  font-size: 13px;
  line-height: 18px;
  color: var(--fg-text-gray);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 동작 버튼 — Figma 상태별 색상 */
.edu-list__action-btn {
  min-width: 76px;
  padding: 8px 10px;
  background: var(--fg-button);
  border: 0;
  border-radius: 4px;
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  white-space: nowrap;
  transition: var(--transition-fast);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.edu-list__action-btn:hover {
  filter: brightness(0.95);
}

.edu-list__action-btn--edit {
  background: #c1d5df;
  color: #fff;
}

.edu-list__action-btn--apply {
  background: var(--fg-button);
  color: #fff;
}

.edu-list__action-btn--applying {
  background: #8eb7ee;
  color: #fff;
}

.edu-list__action-btn--ended {
  background: #fff;
  color: #b3b3b3;
  border: 1px solid #dbdbdb;
}

.edu-list__action-btn--secret {
  background: #e8d9c9;
  color: #fff;
}

/* 강사 셀 — Figma 2073:21157 */
.edu-list__instructor {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  width: 80px;
  overflow: hidden;
}

.edu-list__instructor-avatar {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
}

.edu-list__instructor-name {
  font-size: 16px;
  font-weight: 600;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* legacy alias (다른 화면에서 그대로 쓰는 곳을 위한 보존) */
.edu-list__action-btn--primary {
  background: var(--fg-button);
  color: #fff;
}

.edu-list__action-btn--ghost {
  background: var(--fg-bg-litepp);
  color: var(--fg-button-hover);
}

.edu-list__action-btn--ghost:hover {
  background: #d8dbed;
}

.edu-list__empty {
  padding: 60px 20px;
  text-align: center;
  color: var(--fg-text-gray);
}

/* ========================================================================
   EduList — 우측 슬라이드 패널 (새 강의 만들기 통합)
   ======================================================================== */

.edu-list__main {
  padding: 0;
}

.edu-list__layout {
  display: flex;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.edu-list__content {
  flex: 1 1;
  min-width: 0;
  overflow-y: auto;
}

.edu-list__layout--with-panel .edu-list__content {
  flex: 1 1;
  min-width: 0;
}

/* 우측 슬라이드 패널 — 새 강의 만들기 (Figma 2073:21247) */
.edu-create__panel {
  position: sticky;
  top: 0;
  align-self: flex-start;
  flex: 0 0 728px;
  width: 728px;
  height: calc(100vh - 52px);
  max-height: calc(100vh - 52px);
  margin-left: auto;
  display: flex;
  flex-direction: column;
  background: var(--fg-bg-toolbox);
  color: #fff;
  box-shadow: -4px 0 3.5px rgba(0, 0, 0, 0.2);
  border-radius: 0 16px 0 0;
  animation: agentChatPanelIn 0.18s ease-out;
}

.edu-create__head {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 20px 20px 0;
  flex-shrink: 0;
}

.edu-create__title {
  flex: 1 1;
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: #fff;
}

.edu-create__close {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  padding: 2px;
  transition: var(--transition-fast);
}

.edu-create__close:hover {
  background: rgba(255, 255, 255, 0.08);
}

.edu-create__body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 20px 20px 90px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.edu-create__field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.edu-create__label {
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #fff;
}

.edu-create__input,
.edu-create__textarea {
  width: 100%;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
  outline: none;
  resize: none;
}

.edu-create__textarea {
  height: 125px;
  resize: vertical;
}

.edu-create__input:focus,
.edu-create__textarea:focus {
  border-color: var(--fg-side-hover);
}

.edu-create__select {
  position: relative;
  display: flex;
  align-items: center;
}

.edu-create__select select {
  width: 100%;
  appearance: none;
  -webkit-appearance: none;
  padding: 8px 36px 8px 16px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
  cursor: pointer;
}

.edu-create__select select:focus {
  outline: none;
  border-color: var(--fg-side-hover);
}

.edu-create__select>svg {
  position: absolute;
  right: 12px;
  pointer-events: none;
  color: var(--fg-text-basic);
}

.edu-create__date-input {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
}

.edu-create__date-input:focus-within {
  border-color: var(--fg-side-hover);
}

.edu-create__date-input input {
  flex: 1 1;
  min-width: 0;
  border: 0;
  outline: none;
  background: transparent;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
}

.edu-create__date-input input::placeholder {
  color: var(--fg-text-basic);
}

.edu-create__date-input>svg {
  color: var(--fg-text-gray);
  flex-shrink: 0;
}

.edu-create__models-head {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 20px;
}

.edu-create__models-head .edu-create__label {
  flex: 1 1;
}

.edu-create__check-all {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  color: #f8f8f8;
  font-size: 14px;
  line-height: 20px;
}

.edu-create__check {
  width: 16px;
  height: 16px;
  display: grid;
  place-items: center;
  background: #c2c2c2;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
  transition: var(--transition-fast);
}

.edu-create__check--on {
  background: var(--fg-side-hover);
}

.edu-create__check svg {
  color: #fff;
  display: block;
}

.edu-create__model-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px;
}

.edu-create__models-state {
  padding: 16px 20px;
  font-size: 13px;
  color: var(--fg-text-gray);
  background: var(--fg-bg-card);
  border: 1px solid var(--fg-line);
  border-radius: var(--radius-md);
  text-align: center;
}

.edu-create__models-state--error {
  color: var(--fg-anti-red);
  border-color: var(--fg-anti-red);
  background: var(--error-light);
}

.edu-create__model-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  cursor: pointer;
  transition: var(--transition-fast);
  text-align: left;
  font-family: inherit;
}

.edu-create__model-card:hover {
  border-color: var(--fg-side-hover);
}

.edu-create__model-card--on {
  background: var(--fg-bg-connected);
}

.edu-create__model-text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.edu-create__model-name {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edu-create__model-provider {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: var(--fg-text-gray);
}

.edu-create__model-modality {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  border-radius: var(--radius-full);
  background: var(--fg-bg-card);
  color: var(--fg-text-gray);
  border: 1px solid var(--fg-line);
}

.edu-create__model-modality--chat {
  background: var(--fg-bg-liteblue);
  color: var(--fg-text-purple);
  border-color: transparent;
}

.edu-create__model-modality--image,
.edu-create__model-modality--image_gen {
  background: var(--fg-bg-warm);
  color: var(--fg-orange-warn);
  border-color: transparent;
}

.edu-create__model-modality--embedding {
  background: var(--fg-bg-cool);
  color: var(--fg-text-purple);
  border-color: transparent;
}

.edu-create__model-modality--stt,
.edu-create__model-modality--tts {
  background: var(--fg-bg-cooler);
  color: var(--fg-text-purple);
  border-color: transparent;
}

.edu-create__model-modality--rerank {
  background: var(--fg-bg-litepp);
  color: var(--fg-text-purple);
  border-color: transparent;
}

.edu-create__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  background: var(--fg-bg-toolbox);
}

.edu-create__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  min-height: 42px;
  padding: 6px 12px;
  border: 0;
  border-radius: 12px;
  font-family: inherit;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  transition: var(--transition-fast);
  white-space: nowrap;
}

.edu-create__btn--primary {
  background: var(--fg-button);
}

.edu-create__btn--primary:hover {
  background: var(--fg-button-hover);
}

.edu-create__btn--cancel {
  background: var(--fg-text-gray);
}

.edu-create__btn--cancel:hover {
  background: #6f6f6f;
}

@media (max-width: 1440px) {
  .edu-create__panel {
    flex: 0 0 560px;
    width: 560px;
  }
}

/* ========================================================================
   EduCourse — 수강중인 강의 (학습 성과 + 대화 기록 통합)
   ======================================================================== */

/* 강의 헤더 카드 (Figma 2073:21398) — 단일 행 레이아웃 */
.edu-course__head-card {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 12px 20px;
  background: #f8f8f8;
  border: 0;
  border-radius: 12px;
}

/* 1) 뒤로가기 버튼 */
.edu-course__back {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: var(--fg-text-basic);
  cursor: pointer;
  padding: 0;
}

.edu-course__back:hover {
  color: var(--fg-side-hover);
}

/* 2) Current Class 그린 알약 (240x58) */
.edu-course__current-class {
  flex-shrink: 0;
  width: 240px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 10px 12px;
  background: var(--fg-class-green);
  border: 0;
  border-radius: 12px;
  color: #fff;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
}

.edu-course__current-class:hover {
  filter: brightness(0.95);
}

.edu-course__current-class-icon {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  color: #fff;
  flex-shrink: 0;
}

.edu-course__current-class-text {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.edu-course__current-class-meta {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  line-height: 1;
}

.edu-course__current-class-dday {
  color: var(--fg-yellow);
}

.edu-course__current-class-status {
  color: #f2f2f2;
}

.edu-course__current-class-title {
  font-size: 15px;
  font-weight: 500;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edu-course__current-class-arrow {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  color: #fff;
  flex-shrink: 0;
}

/* 3) 가운데 — 태그 + 제목 + 설명 (flex 1) */
.edu-course__head-main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.edu-course__head-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.edu-course__head-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edu-course__head-desc {
  margin: 0;
  font-size: 13px;
  line-height: 16px;
  color: var(--fg-text-gray);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 4) 우측 통계 — 총 대화 / 학습일 / 기간 / 강사 */
.edu-course__head-stats {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.edu-course__head-stat {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  color: var(--fg-text-basic);
}

.edu-course__head-stat em {
  font-style: normal;
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
}

.edu-course__head-stat b {
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
}

.edu-course__head-stat--icon em {
  font-size: 14px;
  line-height: 1;
  color: var(--fg-text-basic);
}

.edu-course__head-stat-divider {
  width: 1px;
  height: 22px;
  background: var(--fg-line);
}

.edu-course__head-stat svg {
  color: var(--fg-text-basic);
  flex-shrink: 0;
}

.edu-course__head-avatar {
  width: 28px;
  height: 28px;
  display: inline-grid;
  place-items: center;
  background: #bfdbfe;
  border-radius: 9999px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  flex-shrink: 0;
}

.edu-course__head-stat strong {
  font-size: 16px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

/* 5) 강의 상세 보기 버튼 (보라 toolbar 스타일, 32 high) */
.edu-course__head-detail-btn {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 32px;
  padding: 5px 7px 7px;
  background: var(--fg-button);
  border: 0;
  border-radius: 4px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  white-space: nowrap;
  transition: var(--transition-fast);
}

.edu-course__head-detail-btn:hover {
  background: var(--fg-button-hover);
}

.edu-course__head-detail-btn svg {
  flex-shrink: 0;
}

@media (max-width: 1280px) {
  .edu-course__head-card {
    flex-wrap: wrap;
  }

  .edu-course__head-stats {
    flex-wrap: wrap;
  }
}

/* 학습 성과 컨테이너 (Figma 2073:21388) */
.edu-course__progress {
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 12px;
}

.edu-course__section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* 섹션 헤더 — 아이콘 40px + 타이틀/eyebrow 스택 */
.edu-course__section-head {
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 0;
}

.edu-course__section-icon {
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  color: var(--fg-text-basic);
}

.edu-course__section-icon svg {
  width: 28px;
  height: 28px;
}

.edu-course__section-text {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-width: 0;
}

.edu-course__section-head h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
}

.edu-course__section-head p {
  margin: 2px 0 0;
  font-size: 13px;
  line-height: 1;
  color: var(--fg-text-gray);
}

/* AI 실습 — 3블록 (모델별 사용량 wide + 대화 모드 + 상세 설정 활용) */
.edu-course__blocks {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  gap: 20px;
}

.edu-course__block {
  display: flex;
  flex-direction: column;
  gap: 0;
  padding: 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
}

.edu-course__block h4 {
  margin: 0 0 20px;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  color: var(--fg-text-basic);
}

/* 모델별 사용량 — 행: 헤더 위에 막대 아래 */
.edu-course__row-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.edu-course__row-list li {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.edu-course__row-head {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 20px;
}

.edu-course__row-name {
  flex: 1 1;
  font-size: 12px;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edu-course__row-count {
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.edu-course__row-bar {
  height: 7px;
  background: var(--fg-bg-card);
  overflow: hidden;
}

.edu-course__row-bar>span {
  display: block;
  height: 100%;
  background: var(--fg-cyan-bar);
}

/* "미사용 모델 모두 보기" 링크 */
.edu-course__block-footer {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: center;
  gap: 4px;
  margin: 16px 0 0;
  padding: 4px 8px;
  background: transparent;
  border: 0;
  font-family: inherit;
  font-size: 12px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.edu-course__block-footer:hover {
  color: var(--fg-side-hover);
}

/* 대화 모드 / 상세 설정 활용 — 라벨+값 행 */
.edu-course__stat-row {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.edu-course__stat-row li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  font-size: 14px;
  color: var(--fg-text-basic);
  border-top: 1px solid var(--fg-line);
}

.edu-course__stat-row li:first-child {
  border-top: 0;
}

.edu-course__stat-row li b {
  font-size: 22px;
  font-weight: 700;
  color: var(--fg-text-basic);
  line-height: 1;
}

/* 지식베이스 학습 — 첫 카드(2단 stat) + 3개 RAG 카드 */
.edu-course__kb-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
}

.edu-course__kb-upload {
  padding: 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.edu-course__kb-upload-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: var(--fg-text-basic);
}

.edu-course__kb-upload-value {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
}

.edu-course__kb-upload-value b {
  font-size: 22px;
  font-weight: 700;
  color: var(--fg-text-basic);
  line-height: 1;
}

.edu-course__kb-upload-value em {
  font-style: normal;
  font-size: 14px;
  color: var(--fg-text-basic);
}

/* RAG 카드 — 좌측 타이틀+sub 스택, 우측 값+서픽스 */
.edu-course__kb-rag {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 28px 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
}

.edu-course__kb-rag-text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.edu-course__kb-rag-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  color: var(--fg-text-basic);
}

.edu-course__kb-rag-sub {
  margin: 0;
  font-size: 12px;
  color: var(--fg-text-gray);
  line-height: 1;
}

.edu-course__kb-rag-value {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  flex-shrink: 0;
}

.edu-course__kb-rag-value b {
  font-size: 22px;
  font-weight: 700;
  color: var(--fg-text-basic);
  line-height: 1;
}

.edu-course__kb-rag-value em {
  font-style: normal;
  font-size: 14px;
  color: var(--fg-text-basic);
}

/* pill row — 4컬럼 (또는 3컬럼) */
.edu-course__pill-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
}

.edu-course__pill-row--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.edu-course__pill-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  height: 66px;
}

.edu-course__pill-label {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 26px;
  color: var(--fg-text-basic);
}

.edu-course__pill-value {
  font-size: 22px;
  font-weight: 700;
  color: var(--fg-text-basic);
  line-height: 1;
}

/* MCP/에이전트 stat — 값 색상을 파란색(--fg-side-hover)으로 */
.edu-course__pill-row--blue .edu-course__pill-value {
  color: var(--fg-side-hover);
}

/* 프롬프트 첫 카드 — 노란 원 + "1" + "개 활용" */
.edu-course__pill-card--accent {
  background: #fff;
  border-color: var(--fg-line);
}

.edu-course__pill-circle {
  width: 23px;
  height: 23px;
  border-radius: 9999px;
  background: var(--fg-yellow);
  flex-shrink: 0;
}

.edu-course__pill-card--accent .edu-course__pill-value {
  font-size: 22px;
  font-weight: 700;
  color: var(--fg-text-basic);
  margin-left: 4px;
}

.edu-course__pill-suffix {
  font-size: 14px;
  color: var(--fg-text-basic);
  margin-left: 4px;
}

/* MCP 카테고리 row — 회색 배경의 wrapper에 라벨 좌측 + 카드 3개 우측 */
.edu-course__category-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 16px 20px;
  background: #f8f8f8;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  margin-top: 0;
}

.edu-course__category-label {
  font-size: 15px;
  font-weight: 600;
  line-height: 26px;
  color: var(--fg-text-basic);
  flex-shrink: 0;
  margin-right: auto;
}

.edu-course__category-cards {
  display: flex;
  align-items: stretch;
  gap: 20px;
  flex-shrink: 0;
}

.edu-course__category-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  width: 280px;
  padding: 8px 12px;
  background: #fff;
  border: 0;
  border-radius: 8px;
}

.edu-course__category-text {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
}

.edu-course__category-text strong {
  font-size: 14px;
  font-weight: 700;
  color: var(--fg-text-basic);
}

.edu-course__category-text span {
  font-size: 14px;
  color: var(--fg-text-gray);
}

.edu-course__category-value {
  font-size: 22px;
  font-weight: 700;
  color: var(--fg-side-hover);
  line-height: 1;
}

/* MCP 카드 그리드 */
.edu-course__mcp-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 20px;
  margin-top: 0;
}

/* MCP 카드 (Figma 2073:21590) — 화이트 카드 + 토글 + 부제 + 칩 + 회 사용 pill */
.edu-course__mcp-card {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
}

.edu-course__mcp-card-head {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.edu-course__mcp-card-title {
  margin: 0;
  flex: 1 1;
  min-width: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
  word-break: keep-all;
}

.edu-course__mcp-sub {
  margin: 0;
  font-size: 15px;
  font-weight: 400;
  line-height: 24px;
  color: var(--fg-text-basic);
}

.edu-course__mcp-tools {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
}

.edu-course__mcp-tools li {
  display: inline-flex;
  align-items: center;
  padding: 4px 6px;
  background: var(--fg-bg-liteblue);
  border-radius: 4px;
  font-size: 12px;
  color: var(--fg-text-basic);
  white-space: nowrap;
}

/* "0 회 사용" 큰 pill 버튼 */
.edu-course__mcp-use {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  margin: 0;
  padding: 8px 12px;
  background: var(--fg-bg-card);
  border: 0;
  border-radius: 8px;
  width: 100%;
  text-align: center;
}

.edu-course__mcp-use b {
  font-size: 28px;
  font-weight: 600;
  line-height: 40px;
  color: var(--fg-text-basic);
}

.edu-course__mcp-use em {
  font-style: normal;
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-text-basic);
  line-height: 1;
}

/* 에이전트 빌더 — 1 (배포됨/초안) + 6 (3x2 grid) */
.edu-course__agent-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 3fr);
  gap: 20px;
}

.edu-course__agent-deploy {
  padding: 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.edu-course__agent-subgrid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-template-rows: repeat(2, auto);
  gap: 20px;
}

/* 반응형 */
@media (max-width: 1440px) {
  .edu-course__mcp-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 1280px) {
  .edu-course__blocks {
    grid-template-columns: 1fr;
  }

  .edu-course__kb-grid,
  .edu-course__pill-row,
  .edu-course__pill-row--3,
  .edu-course__agent-subgrid,
  .edu-course__mcp-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .edu-course__agent-grid {
    grid-template-columns: 1fr;
  }

  .edu-course__category-row {
    flex-direction: column;
    align-items: stretch;
  }

  .edu-course__category-cards {
    width: 100%;
    flex-wrap: wrap;
  }

  .edu-course__category-card {
    flex: 1 1 200px;
    width: auto;
  }
}

/* ─── 대화 기록 탭 (Figma 2073:21729) ─── */
.edu-course__chatlog {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 12px;
}

/* 툴바: 좌측 탭 + 우측 검색/정렬 */
.edu-course__chatlog-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  height: 42px;
}

.edu-course__chatlog-tabs {
  display: inline-flex;
  align-items: center;
}

.edu-course__chatlog-tab {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 10px;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.edu-course__chatlog-tab:hover {
  color: var(--fg-side-hover);
}

.edu-course__chatlog-tab--active {
  border-bottom-color: var(--fg-text-basic);
}

.edu-course__chatlog-tab-count {
  font-size: 13px;
  font-weight: 400;
  color: var(--fg-text-gray);
  line-height: 1;
}

.edu-course__chatlog-controls {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.edu-course__chatlog-search {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: 240px;
  padding: 7px 12px 7px 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 30px;
}

.edu-course__chatlog-search-input {
  flex: 1 1;
  min-width: 0;
  border: 0;
  outline: none;
  background: transparent;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
}

.edu-course__chatlog-search-input::placeholder {
  color: var(--fg-text-gray);
}

.edu-course__chatlog-search>svg {
  color: var(--fg-text-gray);
  flex-shrink: 0;
}

.edu-course__chatlog-sort {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 122px;
  padding: 8px 8px 8px 16px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 16px;
  line-height: 26px;
  color: var(--fg-text-basic);
  cursor: pointer;
}

.edu-course__chatlog-sort:hover {
  border-color: var(--fg-side-hover);
}

/* 리스트 — 상단 2px 구분선, 각 행 80px 고정, 하단 1px 구분선 */
.edu-course__chatlog-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  border-top: 2px solid var(--fg-text-basic);
}

.edu-course__chatlog-item {
  display: flex;
  align-items: center;
  gap: 20px;
  height: 80px;
  padding: 20px;
  background: #fff;
  border-bottom: 1px solid var(--fg-line);
  cursor: pointer;
  transition: var(--transition-fast);
}

.edu-course__chatlog-item:hover {
  background: var(--fg-bg-card);
}

/* 아이콘 박스 — 40x40, 배경 없음, SVG가 직접 색상 표현 (Figma) */
.edu-course__chatlog-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  background: transparent;
  color: var(--fg-side-hover);
}

.edu-course__chatlog-icon--agent {
  color: var(--fg-class-green);
}

/* 본문 — 제목 14 Medium + 요약 13 gray */
.edu-course__chatlog-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.edu-course__chatlog-title {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edu-course__chatlog-summary {
  margin: 0;
  font-size: 13px;
  color: var(--fg-text-gray);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* 편집 버튼 (에이전트 행에만) */
.edu-course__chatlog-edit {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
  padding: 2px;
}

.edu-course__chatlog-edit:hover {
  background: rgba(0, 0, 0, 0.04);
}

/* 시간 — 90px 고정, 54 Bold + 분전 Regular (gray) */
.edu-course__chatlog-time {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 90px;
  flex-shrink: 0;
  font-size: 14px;
  color: var(--fg-text-gray);
  text-align: right;
  white-space: nowrap;
}

.edu-course__chatlog-time b {
  font-weight: 700;
  color: var(--fg-text-gray);
}

.edu-course__chatlog-time em {
  font-style: normal;
  font-weight: 400;
}

/* 턴 수 — 90px 고정, 7 Bold + 턴 Medium (BLUE) */
.edu-course__chatlog-turns {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 90px;
  flex-shrink: 0;
  font-size: 14px;
  color: var(--fg-side-hover);
  white-space: nowrap;
}

.edu-course__chatlog-turns b {
  font-weight: 700;
}

.edu-course__chatlog-turns em {
  font-style: normal;
  font-weight: 500;
}

/* 우측 화살표 — 28x28 */
.edu-course__chatlog-arrow {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  color: var(--fg-text-basic);
}

/* ========================================================================
   EduEnrolled — 수강중인 강의 (Figma 2073:21357)
   ======================================================================== */

/* 헤딩 행: H1 + 도움말 + 우측 탭 */
.edu-enrolled__heading {
  display: flex;
  align-items: center;
  gap: 4px;
}

.edu-enrolled__heading>.prompt-intro__h1 {
  flex-shrink: 0;
}

.edu-enrolled__heading>.prompt-intro__heading-help {
  margin-right: auto;
}

/* 우측 탭 네비 (학습 성과 / 학생 / 대화 기록) */
.edu-enrolled__tabs {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.edu-enrolled__tab {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 8px 12px;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}

.edu-enrolled__tab:hover {
  color: var(--fg-text-basic);
}

.edu-enrolled__tab--active {
  color: var(--fg-text-basic);
  border-bottom-color: var(--fg-text-basic);
  font-weight: 600;
}

.edu-enrolled__tab-count {
  font-size: 13px;
  font-weight: 500;
  color: var(--fg-text-gray);
}

.edu-enrolled__tab--active .edu-enrolled__tab-count {
  color: var(--fg-side-hover);
  font-weight: 600;
}

/* 학생 탭 — 검색 toolbar + 테이블 (EduMy 스타일 재사용) */
.edu-enrolled__students {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 12px;
}

.edu-enrolled__students-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

/* AI 실습 학습 — block 하단 보조 텍스트 (이내의 모델 모두 보기) */
.edu-course__block-footer {
  margin: 8px 0 0;
  padding-top: 8px;
  border-top: 1px solid var(--fg-line);
  font-size: 12px;
  color: var(--fg-text-gray);
  text-align: center;
}

/* ========================================================================
   EduCourseSteps — 강의 상세 보기 (STEP 목록)
   ======================================================================== */

.edu-steps__root {
  background: var(--fg-bg-dark);
}

.edu-steps__layout {
  display: flex;
  background: var(--fg-bg-content);
  margin: 0 16px;
  border-radius: 16px 16px 0 0;
  min-height: calc(100vh - 52px);
  overflow: hidden;
  box-shadow: 0 0 6.3px 1px rgba(0, 0, 0, 0.26);
}

/* 좁은 collapsed 사이드바 */
.edu-steps__compact-sidebar {
  width: 60px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 16px 0;
  background: var(--fg-bg-content);
  border-right: 1px solid var(--fg-line);
}

.edu-steps__compact-head {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--fg-line);
}

.edu-steps__compact-title {
  margin: 0;
  font-size: 11px;
  font-weight: 600;
  color: var(--fg-text-basic);
  text-align: center;
  writing-mode: horizontal-tb;
  word-break: keep-all;
  padding: 0 4px;
}

.edu-steps__compact-icon {
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.edu-steps__compact-icon:hover {
  background: rgba(0, 0, 0, 0.04);
}

/* STEP 목록 패널 */
.edu-steps__list-panel {
  width: 240px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 12px;
  background: #fff;
  border-right: 1px solid var(--fg-line);
  overflow-y: auto;
}

.edu-steps__course-pill {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  background: var(--fg-bg-publishing);
  color: var(--fg-text-publishing);
  border: 0;
  border-radius: 8px;
  font-family: inherit;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  text-align: left;
  width: 100%;
}

.edu-steps__course-title {
  flex: 1 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edu-steps__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  position: relative;
}

.edu-steps__list::before {
  content: '';
  position: absolute;
  top: 16px;
  bottom: 16px;
  left: 8px;
  width: 1px;
  background: var(--fg-line);
}

.edu-steps__item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 10px 0 10px 0;
  cursor: pointer;
  position: relative;
}

.edu-steps__item-dot {
  flex-shrink: 0;
  width: 9px;
  height: 9px;
  margin-top: 8px;
  background: var(--fg-text-basic);
  border-radius: 9999px;
  z-index: 1;
}

.edu-steps__item--active .edu-steps__item-dot {
  background: var(--fg-button);
  box-shadow: 0 0 0 3px rgba(151, 140, 202, 0.25);
}

.edu-steps__item-body {
  flex: 1 1;
  min-width: 0;
  padding-left: 4px;
}

.edu-steps__item-pill {
  display: inline-block;
  padding: 2px 8px;
  background: var(--fg-text-basic);
  color: #fff;
  border-radius: 9999px;
  font-size: 10px;
  font-weight: 700;
  margin-bottom: 4px;
}

.edu-steps__item--active .edu-steps__item-pill {
  background: var(--fg-button);
}

.edu-steps__item-title {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edu-steps__item-time {
  margin: 2px 0 0;
  font-size: 11px;
  color: var(--fg-text-gray);
}

/* 메인 STEP 디테일 */
.edu-steps__main {
  flex: 1 1;
  min-width: 0;
  background: #fff;
  border-radius: 16px 0 0 0;
  overflow-y: auto;
}

.edu-steps__detail {
  padding: 30px 40px;
}

.edu-steps__detail-head {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--fg-line);
}

.edu-steps__detail-step {
  flex-shrink: 0;
  width: 64px;
  height: 64px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--fg-text-basic);
  color: #fff;
  border-radius: 12px;
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
}

.edu-steps__detail-step strong {
  font-size: 24px;
  font-weight: 800;
  margin-top: 2px;
}

.edu-steps__detail-title {
  flex: 1 1;
  min-width: 0;
}

.edu-steps__detail-title h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.edu-steps__detail-title p {
  margin: 8px 0 0;
  font-size: 14px;
  line-height: 22px;
  color: var(--fg-text-gray);
}

/* ========================================================================
   EduMy — 내 강의 관리 (+ 학생 정보 패널)
   Figma: 86:9398 (1536px content)
   ======================================================================== */

.edu-my__content {
  display: flex;
  flex-direction: column;
  gap: 40px;
  padding: 30px 32px 60px;
}

/* 차트 → 통계 카드 사이는 피그마(Frame 290 → Frame 301) 12px */
.edu-my__chart+.edu-my__stat-grid {
  margin-top: -28px;
}

/* 상단 탭 (개요 / 공유한 강의 자료) */
.edu-my__tabs {
  margin-left: auto;
}

/* 공유한 강의 자료 빈 상태 placeholder */
.edu-my__materials-empty {
  padding: 80px 20px;
  text-align: center;
  color: var(--fg-text-gray);
  font-size: 14px;
}

.edu-my__materials-empty p {
  margin: 0;
}

/* 공유한 강의 자료 (Figma 2073:22370) — 4개 섹션 */
.edu-my__materials {
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 4px;
}

.edu-my__materials-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.edu-my__materials-section h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
}

.edu-my__materials-grid {
  display: grid;
  gap: 20px;
}

.edu-my__materials-grid--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.edu-my__materials-grid--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.edu-my__materials-grid--4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

@media (max-width: 1440px) {
  .edu-my__materials-grid--4 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 1100px) {

  .edu-my__materials-grid--3,
  .edu-my__materials-grid--4 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

/* 카드 공통 */
.edu-my__mat-card {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  transition: var(--transition-fast);
}

.edu-my__mat-card:hover {
  border-color: var(--fg-button);
}

.edu-my__mat-card-head {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.edu-my__mat-card-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
}

.edu-my__mat-card-row .edu-my__mat-card-title {
  flex: 1 1;
  min-width: 0;
}

/* MCP/에이전트 카드 — 제목+날짜를 좌측 컬럼으로 묶음 */
.edu-my__mat-card-titleblock {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.edu-my__mat-card-titleblock .edu-my__mat-card-title {
  white-space: normal;
}

.edu-my__mat-card-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edu-my__mat-card-date {
  margin: 0;
  font-size: 13px;
  color: var(--fg-text-gray);
}

.edu-my__mat-card-subtitle {
  margin: 0;
  font-size: 15px;
  line-height: 24px;
  color: var(--fg-text-basic);
}

.edu-my__mat-card-quote {
  padding: 8px 12px;
  background: var(--fg-bg-card);
  border-radius: 8px;
}

.edu-my__mat-card-quote p {
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: var(--fg-text-gray);
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.edu-my__mat-card-block {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.edu-my__mat-card-block-label {
  font-size: 13px;
  font-weight: 500;
  color: var(--fg-text-basic);
}

/* MCP — 도구 태그 칩 (Figma: bg-liteblue, 4px radius, 6px x-padding) */
.edu-my__mat-card-tools {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 2px;
}

.edu-my__mat-card-tools li {
  display: inline-flex;
  align-items: center;
  padding: 4px 6px;
  background: var(--fg-bg-liteblue);
  border-radius: 4px;
  font-size: 12px;
  color: var(--fg-text-basic);
  white-space: nowrap;
}

/* 에이전트 카드 — 대화/발행중 큰 액션 버튼 (Figma 2073:22463) */
.edu-my__mat-card-actionbtns {
  display: flex;
  gap: 8px;
  width: 100%;
}

.edu-my__mat-card-actionbtn {
  flex: 1 0;
  min-width: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 16px 20px;
  border: 1px solid var(--fg-line);
  border-radius: 8px;
  font-family: inherit;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: var(--transition-fast);
}

/* 대화 — 보라톤 배경 (#eaedfb) + 흐린 테두리 */
.edu-my__mat-card-actionbtn--chat {
  background: #eaedfb;
  color: var(--fg-button-hover);
}

.edu-my__mat-card-actionbtn--chat:hover {
  background: #dde2f7;
}

/* 발행중 — 민트 배경 (#c7ffeb) + 동일색 테두리 (실루엣 없음) */
.edu-my__mat-card-actionbtn--live {
  background: #c7ffeb;
  border-color: #c7ffeb;
  color: var(--fg-text-basic);
  padding: 14px 20px;
}

.edu-my__mat-card-actionbtn--live:hover {
  background: #b3f5dd;
  border-color: #b3f5dd;
}

/* 카드 액션 (공유/실행/편집/삭제) */
.edu-my__mat-card-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  margin-top: auto;
}

.edu-my__mat-card-icon-btn {
  position: relative;
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.edu-my__mat-card-icon-btn:hover {
  background: rgba(0, 0, 0, 0.04);
}

.edu-my__mat-card-icon-btn--danger {
  color: var(--fg-anti-red);
}

.edu-my__mat-card-icon-dot {
  position: absolute;
  top: 5px;
  right: 5px;
  width: 5px;
  height: 5px;
  background: var(--fg-anti-red);
  border-radius: 9999px;
}

/* ── 강의 헤더 카드 (Figma: Frame 251 — 1536x108) ── */
.edu-my__head {
  display: grid;
  grid-template-columns: 28px 240px minmax(0, 644px) auto 112px;
  align-items: center;
  gap: 20px;
  padding: 12px 20px;
  border-radius: 14px;
  background: var(--fg-bg-content);
}

.edu-my__head-back {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  color: var(--fg-text-basic);
  cursor: pointer;
}

.edu-my__head-back:hover {
  color: var(--fg-side-hover);
}

/* 강의 선택 드롭다운 래퍼 (절대 위치 기준점) */
.edu-my__head-pill-wrap {
  position: relative;
  width: 240px;
}

/* 피그마 CurrentClass: 진한 초록(#629351) 배경 + 흰색/노란색 텍스트 */
.edu-my__head-pill {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  width: 240px;
  height: 58px;
  padding: 10px 10px 12px;
  border-radius: 12px;
  background: var(--fg-class-green);
  border: 0;
  font-family: inherit;
  font-size: 14px;
  color: #fff;
  cursor: pointer;
  text-align: left;
}

.edu-my__head-pill:hover {
  filter: brightness(0.95);
}

/* opened — 더 어두운 클래스 그린 (Figma: --class-color---dark #487737) */
.edu-my__head-pill--open {
  background: #487737;
}

.edu-my__head-pill--open:hover {
  filter: none;
}

.edu-my__head-pill-caret {
  display: inline-grid;
  place-items: center;
  flex-shrink: 0;
  color: #fff;
  transition: transform var(--transition-fast);
}

.edu-my__head-pill-caret--up {
  transform: rotate(180deg);
}

/* 드롭다운 패널 (피그마 2061:15735 — 240x450, 흰 배경, 그림자) */
.edu-my__head-dropdown {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 240px;
  max-height: 450px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.06);
  z-index: 40;
}

/* 개인플랜 카드 */
.edu-my__head-dropdown-personal {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  padding: 10px;
  background: #fff;
  border: 0;
  border-radius: 8px;
  font-family: inherit;
  cursor: pointer;
  text-align: left;
  transition: background var(--transition-fast);
}

.edu-my__head-dropdown-personal:hover,
.edu-my__head-dropdown-personal--alt {
  background: var(--fg-bg-card);
}

.edu-my__head-dropdown-avatar {
  display: inline-grid;
  place-items: center;
  width: 25px;
  height: 25px;
  border-radius: 9999px;
  background: var(--fg-text-purple);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
}

.edu-my__head-dropdown-personal-name {
  flex: 1 1;
  min-width: 0;
  font-size: 15px;
  font-weight: 500;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edu-my__head-dropdown-personal-arrow {
  display: inline-grid;
  place-items: center;
  width: 20px;
  height: 20px;
  color: var(--fg-text-gray);
  transform: rotate(-90deg);
  flex-shrink: 0;
}

/* 강의 목록 */
.edu-my__head-dropdown-list {
  flex: 1 1;
  min-height: 0;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 4px;
  overflow-y: auto;
}

.edu-my__head-dropdown-item {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  width: 100%;
  padding: 10px;
  background: #fff;
  border: 0;
  border-radius: 8px;
  font-family: inherit;
  cursor: pointer;
  text-align: left;
  transition: background var(--transition-fast);
}

.edu-my__head-dropdown-item:hover {
  background: var(--fg-bg-card);
}

.edu-my__head-dropdown-item--alt {
  background: var(--fg-bg-card);
}

.edu-my__head-dropdown-row1 {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

.edu-my__head-dropdown-dday {
  color: var(--fg-anti-red);
}

.edu-my__head-dropdown-end {
  color: var(--fg-text-gray);
}

.edu-my__head-dropdown-end--upcoming {
  color: var(--fg-link);
}

.edu-my__head-dropdown-msg {
  padding: 12px 10px;
  font-size: 13px;
  color: var(--fg-text-gray);
  text-align: center;
}

.edu-my__head-dropdown-msg--error {
  color: var(--fg-anti-red);
}

.edu-my__head-dropdown-title {
  width: 100%;
  font-size: 15px;
  font-weight: 500;
  color: var(--fg-text-basic);
  line-height: normal;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edu-my__head-dropdown-period {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  font-size: 13px;
  font-weight: 400;
  color: var(--fg-text-gray);
  white-space: nowrap;
}

.edu-my__head-pill-icon {
  display: inline-grid;
  place-items: center;
  width: 28px;
  height: 28px;
  color: #fff;
  flex-shrink: 0;
}

.edu-my__head-pill-text {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.edu-my__head-pill-row1 {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}

/* D-123 — 배지가 아닌 텍스트, 노란색 */
.edu-my__head-pill .edu-course__pill-dday {
  background: transparent;
  color: #ffd900;
  padding: 0;
  border-radius: 0;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: normal;
  line-height: normal;
}

.edu-my__head-pill-status {
  font-size: 12px;
  font-weight: 600;
  color: #f2f2f2;
}

.edu-my__head-pill-title {
  font-size: 15px;
  font-weight: 500;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: normal;
}

.edu-my__head-pill>svg {
  flex-shrink: 0;
  color: #fff;
}

.edu-my__head-main {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  max-width: 644px;
}

.edu-my__head-title-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.edu-my__head-title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--fg-text-basic);
  line-height: 28px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edu-my__head-desc {
  margin: 0;
  font-size: 13px;
  line-height: 18px;
  color: var(--fg-text-gray);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.edu-my__head-meta {
  display: inline-flex;
  align-items: center;
  gap: 14px;
  white-space: nowrap;
}

.edu-my__head-meta-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  color: var(--fg-text-basic);
}

.edu-my__head-meta-item svg {
  color: var(--fg-text-gray);
  flex-shrink: 0;
}

.edu-my__head-meta-item b {
  font-weight: 700;
}

.edu-my__head-meta-item em {
  font-style: normal;
  margin-left: 2px;
  color: var(--fg-text-gray);
  font-weight: 500;
}

.edu-my__head-meta-coin {
  color: var(--fg-side-hover);
  font-weight: 700;
}

.edu-my__head-meta-coin svg {
  color: var(--fg-side-hover);
}

.edu-my__head-meta-coin em {
  color: var(--fg-side-hover);
  font-weight: 500;
}

.edu-my__head-actions {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.edu-my__head-action-btn {
  min-width: 112px;
  height: 32px;
  padding: 0 12px;
  background: var(--fg-button);
  border: 0;
  border-radius: 6px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: var(--transition-fast);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  white-space: nowrap;
}

.edu-my__head-action-btn:hover {
  background: var(--fg-button-hover);
}

.edu-my__head-action-btn svg {
  flex-shrink: 0;
}

/* ── 강의 동영상 그리드 (Figma: Frame 693) ── */
.edu-my__videos {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.edu-my__videos-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.edu-my__videos-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: var(--fg-text-basic);
}

.edu-my__videos-grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 20px;
}

/* 동영상 카드 — 16:9 썸네일, 좌하단 액션, (선택) 우상단 도구 */
.edu-my__video-card {
  position: relative;
  aspect-ratio: 240 / 135;
  border-radius: 16px;
  overflow: hidden;
  border: 0;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: left;
  color: #ffffff;
  cursor: pointer;
  transition: transform var(--transition-fast), box-shadow var(--transition-fast);
}

.edu-my__video-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}

/* MOCK 썸네일 — 톤별 진한 보라/네이비 그라데이션 */
.edu-my__video-card--navy {
  background:
    radial-gradient(120% 80% at 10% 100%, rgba(139, 92, 246, 0.55) 0%, rgba(0, 0, 0, 0) 60%),
    linear-gradient(135deg, #1e1b4b 0%, #312e81 45%, #4338ca 100%);
}

.edu-my__video-card--indigo {
  background:
    radial-gradient(120% 80% at 90% 100%, rgba(59, 130, 246, 0.55) 0%, rgba(0, 0, 0, 0) 65%),
    linear-gradient(135deg, #312e81 0%, #4338ca 55%, #1d4ed8 100%);
}

/* 가운데 타이틀/서브타이틀 오버레이 */
.edu-my__video-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 14px 16px;
  text-align: center;
  pointer-events: none;
}

.edu-my__video-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.25;
  letter-spacing: -0.2px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.55);
}

.edu-my__video-sub {
  margin: 4px 0 0;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.3;
  color: rgba(255, 255, 255, 0.92);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

/* 우상단 도구 (편집/제거) */
.edu-my__video-tools {
  position: absolute;
  top: 10px;
  right: 10px;
  display: inline-flex;
  gap: 4px;
  z-index: 2;
}

.edu-my__video-tool {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 0;
  background: #ffffff;
  color: var(--fg-text-basic);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 3px 4.5px rgba(0, 0, 0, 0.17);
  transition: var(--transition-fast);
}

.edu-my__video-tool:hover {
  color: var(--fg-button);
  transform: translateY(-1px);
}

/* 좌하단 액션 (재생/이미지) */
.edu-my__video-actions {
  position: absolute;
  left: 10px;
  bottom: 10px;
  display: inline-flex;
  gap: 4px;
  z-index: 2;
}

.edu-my__video-action {
  width: 24px;
  height: 24px;
  border-radius: 12px;
  border: 0;
  background: var(--fg-button-hover);
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  filter: drop-shadow(0 4px 2.4px rgba(0, 0, 0, 0.39));
  transition: var(--transition-fast);
}

.edu-my__video-action:hover {
  background: var(--fg-button);
}

/* + 추가 카드 (점선) */
.edu-my__video-add {
  aspect-ratio: 240 / 135;
  border-radius: 16px;
  border: 1.5px dashed var(--fg-text-gray);
  background: transparent;
  color: var(--fg-text-gray);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: var(--transition-fast);
}

.edu-my__video-add:hover {
  border-color: var(--fg-button);
  color: var(--fg-button);
  background: var(--fg-bg-litepp);
}

@media (max-width: 1440px) {
  .edu-my__videos-grid {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}

@media (max-width: 1200px) {
  .edu-my__videos-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}

/* ── 일별 요청량 차트 (Figma: Frame 303) ── */
.edu-my__chart {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.edu-my__chart-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.edu-my__chart-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--fg-text-basic);
  line-height: 28px;
}

.edu-my__chart-tabs {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

/* 차트 기간 탭 (Figma 2073:22013) — category-tab 패턴 */
.edu-my__chart-tab {
  padding: 10px;
  background: transparent;
  border: 0;
  border-bottom: 2px solid transparent;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 1;
  color: var(--fg-text-basic);
  cursor: pointer;
  transition: var(--transition-fast);
}

.edu-my__chart-tab:hover {
  color: var(--fg-side-hover);
}

.edu-my__chart-tab--active {
  border-bottom-color: var(--fg-text-basic);
}

.edu-my__chart-refresh {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-gray);
  cursor: pointer;
}

.edu-my__chart-refresh:hover {
  background: var(--fg-bg-card);
  color: var(--fg-text-basic);
}

.edu-my__chart-body {
  display: grid;
  grid-template-columns: 1fr 369px;
  gap: 20px;
  align-items: stretch;
}

/* 차트 바 영역 — Figma 2073:22022 (18개 컬럼, 50px x 226px 영역) */
.edu-my__chart-bars {
  position: relative;
  display: flex;
  align-items: flex-end;
  gap: 10px;
  overflow-x: auto;
}

.edu-my__chart-col {
  flex: 0 0 50px;
  width: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}

.edu-my__chart-bar-value {
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
  color: #7362c2;
  text-align: center;
}

.edu-my__chart-bar-track {
  width: 20px;
  height: 182px;
  background: var(--fg-bg-card, #fbfbfb);
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.edu-my__chart-bar-fill {
  width: 20px;
  background: #cbd1ef;
}

.edu-my__chart-bar-label {
  font-size: 12px;
  font-weight: 400;
  line-height: 1;
  color: var(--fg-text-basic);
  text-align: center;
  white-space: nowrap;
}

/* 모델 사용량 카드 (Figma 2073:22114) — 흰 배경 + 회색 테두리 + 4행 (gap 20) */
.edu-my__chart-rank {
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px;
  background: #fff;
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  align-self: stretch;
}

.edu-my__chart-rank-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.edu-my__chart-rank-head {
  display: flex;
  align-items: center;
  gap: 4px;
  height: 20px;
  font-size: 12px;
  color: var(--fg-text-basic);
}

.edu-my__chart-rank-name {
  flex: 1 1;
  min-width: 0;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edu-my__chart-rank-count {
  font-size: 12px;
  font-weight: 600;
  color: var(--fg-text-basic);
}

.edu-my__chart-rank-track {
  height: 7px;
  background: var(--fg-bg-card);
  overflow: hidden;
}

.edu-my__chart-rank-fill {
  display: block;
  height: 100%;
  background: var(--fg-cyan-bar);
}

/* ── 강의 내 활동 통계 (Figma: Frame 301 — 3x2)
   회색 1px 라인 위에 #fbfbfb 셀 6개. 컨테이너에 border + radius. ── */
.edu-my__stat-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-template-rows: 56px 52px;
  gap: 1px;
  background: var(--fg-line);
  border: 1px solid var(--fg-line);
  border-radius: 12px;
  overflow: hidden;
}

.edu-my__stat-cell {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  background: var(--fg-bg-card);
}

.edu-my__stat-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  color: var(--fg-text-basic);
  background: transparent;
  border: 0;
}

.edu-my__stat-icon svg {
  width: 100%;
  height: 100%;
}

.edu-my__stat-body {
  display: flex;
  flex: 1 1;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  white-space: nowrap;
}

.edu-my__stat-label {
  font-size: 14px;
  font-weight: 700;
  color: var(--fg-text-basic);
  white-space: nowrap;
}

.edu-my__stat-metrics {
  display: inline-flex;
  align-items: center;
  gap: 16px;
}

.edu-my__stat-metric {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  color: var(--fg-text-gray);
  white-space: nowrap;
}

.edu-my__stat-metric b {
  font-size: 22px;
  font-weight: 700;
  color: var(--fg-class-green);
  line-height: 1;
}

.edu-my__stat-metric em {
  font-style: normal;
  font-weight: 400;
  color: var(--fg-text-gray);
  line-height: 1;
}

@media (max-width: 1280px) {
  .edu-my__stat-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: auto;
  }
}

/* ── 학생 관리 테이블 (Figma: Frame 318) ── */
.edu-my__students {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.edu-my__students-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.edu-my__students-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: var(--fg-text-basic);
  line-height: 28px;
}

.edu-my__students-search {
  position: relative;
  width: 240px;
}

.edu-my__students-search-input {
  width: 100%;
  height: 42px;
  padding: 0 40px 0 16px;
  border: 1px solid var(--fg-line);
  border-radius: 30px;
  font-size: 13px;
  color: var(--fg-text-basic);
  background: #fff;
  outline: none;
  font-family: inherit;
}

.edu-my__students-search-input:focus {
  border-color: var(--fg-button);
}

.edu-my__students-search>svg {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--fg-text-gray);
  pointer-events: none;
}

.edu-my__students-table {
  display: flex;
  flex-direction: column;
}

.edu-my__students-thead,
.edu-my__students-row {
  display: grid;
  grid-template-columns: 280px 1fr 200px 120px 72px;
  align-items: center;
  gap: 40px;
  padding: 0 20px;
}

.edu-my__students-thead {
  height: 57px;
  border-bottom: 1px solid var(--fg-line);
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-gray);
}

.edu-my__students-row {
  height: 64px;
  border-bottom: 1px solid var(--fg-line);
  cursor: pointer;
  font-size: 14px;
  color: var(--fg-text-basic);
  transition: var(--transition-fast);
}

.edu-my__students-row:hover {
  background: var(--fg-bg-card);
}

.edu-my__col-student {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.edu-my__avatar-name {
  font-size: 14px;
  font-weight: 500;
  color: var(--fg-text-basic);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edu-my__col-courses {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px 14px;
  min-width: 0;
}

.edu-my__col-courses a {
  font-size: 14px;
  color: var(--fg-text-basic);
  text-decoration: underline;
  text-underline-offset: 2px;
  white-space: nowrap;
}

.edu-my__col-courses a:hover {
  color: var(--fg-side-hover);
}

.edu-my__col-period {
  font-size: 14px;
  color: var(--fg-text-gray);
  white-space: nowrap;
}

.edu-my__col-status {
  display: inline-flex;
  align-items: center;
}

.edu-my__col-action {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  justify-content: flex-end;
}

.edu-my__avatar {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  border-radius: 9999px;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
}

.edu-my__avatar--lg {
  width: 64px;
  height: 64px;
  font-size: 22px;
}

/* 상태 pill */
.edu-my__status-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

.edu-my__status-pill--active {
  background: #daffd7;
  color: #3cb832;
}

.edu-my__status-pill--mine {
  background: #ffe4b8;
  color: #ea5440;
}

.edu-my__status-pill--pending {
  background: #d0f8ff;
  color: #3cb6ca;
}

.edu-my__status-dot {
  width: 10px;
  height: 10px;
  border-radius: 9999px;
  background: currentColor;
}

.edu-my__row-icon-btn {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: var(--fg-text-gray);
  cursor: pointer;
  transition: var(--transition-fast);
}

.edu-my__row-icon-btn:hover {
  background: var(--fg-bg-card);
  color: var(--fg-text-basic);
}

/* 우측 슬라이드 패널 - 회원 정보 (Figma 2073:22889 — 768px wide, 우측 끝에 붙음) */
.edu-my__panel {
  position: relative;
  flex: 0 0 768px;
  width: 768px;
  display: flex;
  flex-direction: column;
  background: var(--fg-bg-toolbox);
  color: #fff;
  box-shadow: -4px 0 3.5px rgba(0, 0, 0, 0.2);
  border-radius: 0 16px 0 0;
  animation: agentChatPanelIn 0.18s ease-out;
}

/* 패널이 열렸을 때 prompt__layout의 우측 16px 여백을 제거하여 패널이 뷰포트 우측 끝에 붙도록 함 */
.prompt:has(.edu-my__panel) .prompt__layout,
.prompt:has(.edu-create__panel) .prompt__layout {
  margin-right: 0;
}

.edu-my__panel-head {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 20px 20px 0;
  flex-shrink: 0;
}

.edu-my__panel-title {
  flex: 1 1;
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: #fff;
}

.edu-my__panel-close {
  width: 32px;
  height: 32px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  padding: 2px;
  transition: var(--transition-fast);
}

.edu-my__panel-close:hover {
  background: rgba(255, 255, 255, 0.08);
}

.edu-my__panel-body {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  padding: 20px 20px 90px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

/* 프로필 */
.edu-my__panel-profile {
  display: flex;
  align-items: center;
  gap: 12px;
}

.edu-my__avatar--lg {
  width: 80px;
  height: 80px;
  font-size: 28px;
  flex-shrink: 0;
}

.edu-my__panel-info {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.edu-my__panel-name {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: #fff;
}

.edu-my__panel-email {
  margin: 0;
  font-size: 13px;
  color: var(--fg-blue-lite);
  line-height: 20px;
}

.edu-my__panel-meta {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #fff;
  line-height: 20px;
}

.edu-my__panel-meta-divider {
  width: 1px;
  height: 12px;
  background: rgba(255, 255, 255, 0.4);
}

/* 섹션 */
.edu-my__panel-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.edu-my__panel-section-title {
  margin: 0;
  padding: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  color: #fff;
  text-transform: none;
  letter-spacing: 0;
}

/* 강의 카드 — 펼침/접힘 공통 wrapper */
.edu-my__panel-course {
  display: flex;
  flex-direction: column;
}

/* 헤더 행 (접힘 카드 자체이기도 함) */
.edu-my__panel-course-head {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 16px 16px 20px;
  background: transparent;
  border: 1px solid var(--fg-text-gray);
  border-radius: 12px;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: var(--transition-fast);
  width: 100%;
}

.edu-my__panel-course-head:hover {
  border-color: #fff;
}

/* 펼친 카드 — 헤더는 진한 elev 색상, 흰 테두리, 하단 코너 직각 */
.edu-my__panel-course--active .edu-my__panel-course-head {
  background: var(--fg-bg-toolbox-elev);
  border-color: #fff;
  border-radius: 12px 12px 0 0;
}

.edu-my__panel-course-title {
  flex: 1 1;
  min-width: 0;
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.edu-my__panel-dday {
  flex-shrink: 0;
  background: transparent;
  color: var(--fg-orange-warn);
  padding: 0;
  border-radius: 0;
  font-size: 12px;
  font-weight: 600;
  line-height: 1;
}

.edu-my__panel-arrow {
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  background: transparent;
  border: 0;
  color: #fff;
  cursor: pointer;
  padding: 2px;
  flex-shrink: 0;
  transition: transform 0.2s ease;
}

.edu-my__panel-course--active .edu-my__panel-arrow {
  transform: rotate(180deg);
}

/* 펼친 카드 본문 — 1px gap으로 회색선 효과 */
.edu-my__panel-course-body {
  display: flex;
  flex-direction: column;
  gap: 1px;
  padding: 0;
  background: var(--fg-text-gray);
  border: 1px solid #fff;
  border-top: 0;
  border-radius: 0 0 12px 12px;
  overflow: hidden;
}

.edu-my__panel-course-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 20px;
  background: var(--fg-bg-toolbox);
}

.edu-my__panel-course-row svg {
  width: 28px;
  height: 28px;
  color: #fff;
  flex-shrink: 0;
}

.edu-my__panel-course-row-label {
  flex: 1 1;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
}

.edu-my__panel-course-row-value {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  white-space: nowrap;
}

.edu-my__panel-course-row-value b {
  font-size: 22px;
  font-weight: 700;
  color: var(--fg-yellow);
  line-height: 1;
}

.edu-my__panel-course-row-value em {
  font-style: normal;
  font-size: 14px;
  font-weight: 400;
  color: var(--fg-line);
}

.edu-my__panel-course-row-multi {
  display: inline-flex;
  align-items: center;
  gap: 16px;
}

/* 상태 pill */
.edu-my__panel-status-pill {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 6px 10px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}

.edu-my__panel-status-pill .edu-my__panel-status-dot {
  width: 10px;
  height: 10px;
  border-radius: 9999px;
  background: currentColor;
}

.edu-my__panel-status-pill--active {
  background: #daffd7;
  color: #3cb832;
}

.edu-my__panel-status-pill--mine {
  background: #ffe4b8;
  color: #ea5440;
}

/* "강의 전체 모두 보기 (12)" */
.edu-my__panel-more {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  align-self: center;
  padding: 8px;
  background: transparent;
  border: 0;
  font-family: inherit;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
  transition: var(--transition-fast);
}

.edu-my__panel-more:hover {
  color: var(--fg-blue-lite);
}

.edu-my__panel-more svg {
  flex-shrink: 0;
}

/* 푸터 — 절대 하단 (edu-create와 동일한 패턴) */
.edu-my__panel-footer {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px;
  background: var(--fg-bg-toolbox);
}

.edu-my__panel-btn--danger {
  background: var(--fg-orange-warn);
}

.edu-my__panel-btn--danger:hover {
  background: #e66800;
}

@media (max-width: 1600px) {
  .edu-my__panel {
    flex: 0 0 600px;
    width: 600px;
  }
}

@media (max-width: 1280px) {
  .edu-my__panel {
    flex: 0 0 480px;
    width: 480px;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/Edu.css"],"names":[],"mappings":"AAAA;;;6EAG6E;;AAE7E,2CAA2C;AAC3C;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;;;kDAGkD;AAClD;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,4BAA4B;EAC5B,gBAAgB;EAChB;;;0CAGwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;EAClC,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yCAAyC;EACzC,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA,QAAQ;AACR;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;EAC3B,6CAA6C;EAC7C,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,2CAA2C;AAC3C;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uCAAuC;EACvC,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,4BAA4B;AAC5B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,2CAA2C;AAC3C;EACE,4BAA4B;EAC5B,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;;6EAE6E;;AAE7E;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAW;EACX,YAAY;AACd;;AAEA,6CAA6C;AAC7C;EACE,gBAAgB;EAChB,MAAM;EACN,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,0BAA0B;EAC1B,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,WAAW;EACX,2CAA2C;EAC3C,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,wBAAwB;EACxB,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,6BAA6B;EAC7B,gCAAgC;EAChC,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;EAC7B,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;;EAEE,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;;6EAE6E;;AAE7E,4CAA4C;AAC5C;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,uBAAuB;EACvB,iCAAiC;EACjC,SAAS;EACT,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA,mCAAmC;AACnC;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,6CAA6C;AAC7C;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,oBAAoB;EACpB,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,0BAA0B;AAC5B;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAO;EACP,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,8BAA8B;AAChC;;AAEA,sBAAsB;AACtB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA,qCAAqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE,2BAA2B;AAC7B;;AAEA,oCAAoC;AACpC;EACE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,aAAa;AACf;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,oDAAoD;EACpD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,mCAAmC;EACnC,SAAS;AACX;;AAEA,QAAQ;AACR;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;;;;;IAKE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;AACF;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iDAAiD;AACjD;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,mCAAmC;AACnC;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,qBAAqB;AACrB;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,+BAA+B;AACjC;;AAEA,8CAA8C;AAC9C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;6EAE6E;;AAE7E,0BAA0B;AAC1B;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,iCAAiC;AACjC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;;6EAE6E;;AAE7E;EACE,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,cAAc;EACd,4BAA4B;EAC5B,8BAA8B;EAC9B,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,2BAA2B;EAC3B,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA,eAAe;AACf;EACE,YAAY;EACZ,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mCAAmC;EACnC,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,SAAS;EACT,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,eAAe;EACf,gCAAgC;EAChC,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,+CAA+C;AACjD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gCAAgC;EAChC,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;;;6EAG6E;;AAE7E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA,mDAAmD;AACnD;EACE,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;;EAEE;;IAEE,gDAAgD;EAClD;AACF;;AAEA,UAAU;AACV;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA,kEAAkE;AAClE;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,kBAAkB;EAClB,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,SAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kCAAkC;AACpC;;AAEA,mCAAmC;AACnC;EACE,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA,qDAAqD;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;EACjC,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,gEAAgE;AAChE;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,yEAAyE;EACzE,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;EACzB,cAAc;AAChB;;AAEA,UAAU;AACV;EACE,SAAO;EACP,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,4BAA4B;AAC5B;EACE,uBAAuB;EACvB,cAAc;EACd,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,4BAA4B;EAC5B,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,+EAA+E;AACjF;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,kCAAkC;AAClC;EACE;;kEAEgE;AAClE;;AAEA;EACE;;kEAEgE;AAClE;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,oBAAoB;EACpB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2CAA2C;EAC3C,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,oBAAoB;EACpB,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,kCAAkC;EAClC,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,oDAAoD;EACpD,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;EACE,uBAAuB;EACvB,mBAAmB;EACnB,wCAAwC;EACxC,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oCAAoC;EACpC,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,oBAAoB;AACtB;;AAEA,yDAAyD;AACzD;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sCAAsC;EACtC,aAAa;EACb,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,8BAA8B;AAChC;;AAEA;yDACyD;AACzD;EACE,aAAa;EACb,gDAAgD;EAChD,6BAA6B;EAC7B,QAAQ;EACR,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,2BAA2B;EAC3B,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE;IACE,gDAAgD;IAChD,wBAAwB;EAC1B;AACF;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,iDAAiD;EACjD,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,uCAAuC;EACvC,eAAe;EACf,eAAe;EACf,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,iEAAiE;AACjE;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,WAAW;EACX,2CAA2C;EAC3C,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA,mEAAmE;AACnE;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,QAAQ;AACR;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,oCAAoC;AACtC;;AAEA,OAAO;AACP;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,4BAA4B;EAC5B,uBAAuB;EACvB,qCAAqC;EACrC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA,4CAA4C;AAC5C;EACE,qCAAqC;EACrC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,4BAA4B;EAC5B,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,UAAU;EACV,+BAA+B;EAC/B,sBAAsB;EACtB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;EACd;AACF","sourcesContent":["/* ========================================================================\n   Edu — 강의 영역\n   사이드바·인트로 공통 스타일은 Prompt.css 재사용\n   ======================================================================== */\n\n/* 사이드바 — 새 강의 / 강의 타임라인 추가 강조 박스 (Figma) */\n.edu-sidebar__new {\n  background: var(--fg-bg-mychat);\n  font-weight: 600;\n}\n\n.edu-sidebar__new:hover {\n  background: #d8dbed;\n}\n\n.edu-sidebar__new--active {\n  background: #fff;\n  font-weight: 600;\n}\n\n.edu-sidebar__timeline {\n  background: #cae6e5;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.edu-sidebar__timeline:hover {\n  background: #b8dcdb;\n}\n\n.edu-sidebar__timeline--active {\n  background: #fff;\n  font-weight: 600;\n}\n\n.edu-sidebar__spacer {\n  display: block;\n  height: 20px;\n}\n\n/* ─────────────────────────────────────────────\n   사이드바 접힘 상태 (Figma 2030:14844 — sidebar closed)\n   너비 64px · 아이콘만 노출 · 32x32 버튼\n   ───────────────────────────────────────────── */\n.edu-sidebar--collapsed {\n  width: 64px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 24px;\n  padding: 30px 16px;\n  background: var(--fg-bg-content);\n  border-top-left-radius: 16px;\n  overflow: hidden;\n  transition:\n    width 0.28s cubic-bezier(0.4, 0, 0.2, 1),\n    padding 0.28s cubic-bezier(0.4, 0, 0.2, 1),\n    gap 0.28s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.edu-sidebar--collapsed>* {\n  animation: eduSidebarFadeIn 0.24s ease both;\n}\n\n@keyframes eduSidebarFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(2px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.edu-sidebar__collapsed-nav {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n}\n\n.edu-sidebar__icon-btn {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n  padding: 0;\n}\n\n.edu-sidebar__icon-btn:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.edu-sidebar__icon-btn--active {\n  background: #fff;\n}\n\n.edu-sidebar__icon-btn--toggle {\n  color: var(--fg-text-basic);\n}\n\n.edu-sidebar__icon-btn--new {\n  background: var(--fg-bg-mychat);\n}\n\n.edu-sidebar__icon-btn--new:hover {\n  background: #d8dbed;\n}\n\n.edu-sidebar__icon-btn--new.edu-sidebar__icon-btn--active {\n  background: #fff;\n}\n\n.edu-sidebar__icon-btn--timeline {\n  background: #cae6e5;\n}\n\n.edu-sidebar__icon-btn--timeline:hover {\n  background: #b8dcdb;\n}\n\n.edu-sidebar__icon-btn--timeline.edu-sidebar__icon-btn--active {\n  background: #fff;\n}\n\n/* 통계/생성 버튼 행 */\n.edu-list__top-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.edu-list__stats {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* 탭 + 우측 컨트롤 */\n.edu-list__tab-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  /* border-bottom: 1px solid var(--fg-line); */\n  flex-wrap: wrap;\n}\n\n.edu-list__tabs {\n  display: flex;\n}\n\n.edu-list__tab {\n  padding: 12px 16px;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  margin-bottom: -1px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.edu-list__tab span {\n  margin-left: 4px;\n  color: var(--fg-text-gray);\n  font-size: 13px;\n}\n\n.edu-list__tab:hover {\n  color: var(--fg-button-hover);\n}\n\n.edu-list__tab--active {\n  border-bottom-color: var(--fg-text-basic);\n  color: var(--fg-text-basic);\n  font-weight: 600;\n}\n\n.edu-list__tab-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  /* padding-bottom: 8px; */\n}\n\n/* 테이블 */\n.edu-list__table-wrap {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.edu-list__table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 14px;\n}\n\n.edu-list__table thead th {\n  padding: 20px;\n  font-weight: 500;\n  font-size: 14px;\n  text-align: center;\n  color: var(--fg-text-basic);\n  border-bottom: 1px solid var(--fg-text-basic);\n  white-space: nowrap;\n  background: transparent;\n}\n\n/* Figma 2073:21154 — 컬럼별 폭 (헤더+바디 동시 적용) */\n.edu-list__table th:nth-child(1),\n.edu-list__table td:nth-child(1) {\n  width: 75px;\n  text-align: center;\n}\n\n.edu-list__table th:nth-child(3),\n.edu-list__table td:nth-child(3) {\n  width: 80px;\n  text-align: center;\n}\n\n.edu-list__table th:nth-child(4),\n.edu-list__table td:nth-child(4) {\n  width: 160px;\n  text-align: center;\n}\n\n.edu-list__table th:nth-child(5),\n.edu-list__table td:nth-child(5) {\n  width: 90px;\n  text-align: center;\n}\n\n.edu-list__table th:nth-child(6),\n.edu-list__table td:nth-child(6) {\n  width: 90px;\n  text-align: center;\n}\n\n.edu-list__table th:nth-child(7),\n.edu-list__table td:nth-child(7) {\n  width: 100px;\n  text-align: center;\n}\n\n.edu-list__table tbody tr {\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.edu-list__table tbody tr:hover {\n  background: var(--fg-bg-card);\n}\n\n.edu-list__table tbody td {\n  padding: 16px;\n  vertical-align: top;\n  border-bottom: 1px solid var(--fg-line);\n  color: var(--fg-text-basic);\n  vertical-align: middle;\n}\n\n.edu-list__cell-light {\n  color: var(--fg-text-gray);\n  white-space: nowrap;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.edu-list__price {\n  color: var(--fg-side-hover);\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  text-align: right;\n  width: 90px;\n}\n\n.edu-list__price b {\n  font-weight: 700;\n}\n\n.edu-list__price small {\n  margin-left: 4px;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.edu-list__cell-members {\n  color: var(--fg-text-basic);\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  text-align: right;\n  width: 90px;\n}\n\n.edu-list__cell-members b {\n  font-weight: 700;\n}\n\n.edu-list__cell-members span {\n  color: var(--fg-text-gray);\n  font-weight: 500;\n}\n\n/* 상태 pill — Figma 색상 매핑 */\n.edu-list__status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.edu-list__status-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 9999px;\n  background: currentColor;\n}\n\n.edu-list__status--enrolled {\n  background: #daffd7;\n  color: #3cb832;\n}\n\n.edu-list__status--open {\n  background: #d0f8ff;\n  color: #3cb6ca;\n}\n\n.edu-list__status--mine {\n  background: #ffe4b8;\n  color: #ea5440;\n}\n\n.edu-list__status--ended {\n  background: #f2f2f2;\n  color: #8c8c8c;\n}\n\n/* 제목 셀 */\n.edu-list__title-cell {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  max-width: 520px;\n}\n\n.edu-list__tag {\n  flex-shrink: 0;\n  padding: 3px 10px;\n  border: 1px solid var(--fg-text-basic);\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  line-height: 18px;\n}\n\n.edu-list__title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  line-height: 20px;\n}\n\n.edu-list__summary {\n  margin: 4px 0 0;\n  font-size: 13px;\n  line-height: 18px;\n  color: var(--fg-text-gray);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* 동작 버튼 — Figma 상태별 색상 */\n.edu-list__action-btn {\n  min-width: 76px;\n  padding: 8px 10px;\n  background: var(--fg-button);\n  border: 0;\n  border-radius: 4px;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 500;\n  color: #fff;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: var(--transition-fast);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n}\n\n.edu-list__action-btn:hover {\n  filter: brightness(0.95);\n}\n\n.edu-list__action-btn--edit {\n  background: #c1d5df;\n  color: #fff;\n}\n\n.edu-list__action-btn--apply {\n  background: var(--fg-button);\n  color: #fff;\n}\n\n.edu-list__action-btn--applying {\n  background: #8eb7ee;\n  color: #fff;\n}\n\n.edu-list__action-btn--ended {\n  background: #fff;\n  color: #b3b3b3;\n  border: 1px solid #dbdbdb;\n}\n\n.edu-list__action-btn--secret {\n  background: #e8d9c9;\n  color: #fff;\n}\n\n/* 강사 셀 — Figma 2073:21157 */\n.edu-list__instructor {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  width: 80px;\n  overflow: hidden;\n}\n\n.edu-list__instructor-avatar {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  font-size: 12px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.edu-list__instructor-name {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* legacy alias (다른 화면에서 그대로 쓰는 곳을 위한 보존) */\n.edu-list__action-btn--primary {\n  background: var(--fg-button);\n  color: #fff;\n}\n\n.edu-list__action-btn--ghost {\n  background: var(--fg-bg-litepp);\n  color: var(--fg-button-hover);\n}\n\n.edu-list__action-btn--ghost:hover {\n  background: #d8dbed;\n}\n\n.edu-list__empty {\n  padding: 60px 20px;\n  text-align: center;\n  color: var(--fg-text-gray);\n}\n\n/* ========================================================================\n   EduList — 우측 슬라이드 패널 (새 강의 만들기 통합)\n   ======================================================================== */\n\n.edu-list__main {\n  padding: 0;\n}\n\n.edu-list__layout {\n  display: flex;\n  height: 100%;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.edu-list__content {\n  flex: 1;\n  min-width: 0;\n  overflow-y: auto;\n}\n\n.edu-list__layout--with-panel .edu-list__content {\n  flex: 1 1 0;\n  min-width: 0;\n}\n\n/* 우측 슬라이드 패널 — 새 강의 만들기 (Figma 2073:21247) */\n.edu-create__panel {\n  position: sticky;\n  top: 0;\n  align-self: flex-start;\n  flex: 0 0 728px;\n  width: 728px;\n  height: calc(100vh - 52px);\n  max-height: calc(100vh - 52px);\n  margin-left: auto;\n  display: flex;\n  flex-direction: column;\n  background: var(--fg-bg-toolbox);\n  color: #fff;\n  box-shadow: -4px 0 3.5px rgba(0, 0, 0, 0.2);\n  border-radius: 0 16px 0 0;\n  animation: agentChatPanelIn 0.18s ease-out;\n}\n\n.edu-create__head {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 20px 20px 0;\n  flex-shrink: 0;\n}\n\n.edu-create__title {\n  flex: 1;\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: #fff;\n}\n\n.edu-create__close {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: #fff;\n  cursor: pointer;\n  padding: 2px;\n  transition: var(--transition-fast);\n}\n\n.edu-create__close:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.edu-create__body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 20px 20px 90px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.edu-create__field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.edu-create__label {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: #fff;\n}\n\n.edu-create__input,\n.edu-create__textarea {\n  width: 100%;\n  padding: 8px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  outline: none;\n  resize: none;\n}\n\n.edu-create__textarea {\n  height: 125px;\n  resize: vertical;\n}\n\n.edu-create__input:focus,\n.edu-create__textarea:focus {\n  border-color: var(--fg-side-hover);\n}\n\n.edu-create__select {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.edu-create__select select {\n  width: 100%;\n  appearance: none;\n  -webkit-appearance: none;\n  padding: 8px 36px 8px 16px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n}\n\n.edu-create__select select:focus {\n  outline: none;\n  border-color: var(--fg-side-hover);\n}\n\n.edu-create__select>svg {\n  position: absolute;\n  right: 12px;\n  pointer-events: none;\n  color: var(--fg-text-basic);\n}\n\n.edu-create__date-input {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 12px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n}\n\n.edu-create__date-input:focus-within {\n  border-color: var(--fg-side-hover);\n}\n\n.edu-create__date-input input {\n  flex: 1;\n  min-width: 0;\n  border: 0;\n  outline: none;\n  background: transparent;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n}\n\n.edu-create__date-input input::placeholder {\n  color: var(--fg-text-basic);\n}\n\n.edu-create__date-input>svg {\n  color: var(--fg-text-gray);\n  flex-shrink: 0;\n}\n\n.edu-create__models-head {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  height: 20px;\n}\n\n.edu-create__models-head .edu-create__label {\n  flex: 1;\n}\n\n.edu-create__check-all {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  color: #f8f8f8;\n  font-size: 14px;\n  line-height: 20px;\n}\n\n.edu-create__check {\n  width: 16px;\n  height: 16px;\n  display: grid;\n  place-items: center;\n  background: #c2c2c2;\n  border: 0;\n  border-radius: 4px;\n  cursor: pointer;\n  padding: 0;\n  flex-shrink: 0;\n  transition: var(--transition-fast);\n}\n\n.edu-create__check--on {\n  background: var(--fg-side-hover);\n}\n\n.edu-create__check svg {\n  color: #fff;\n  display: block;\n}\n\n.edu-create__model-grid {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 4px;\n}\n\n.edu-create__models-state {\n  padding: 16px 20px;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n  background: var(--fg-bg-card);\n  border: 1px solid var(--fg-line);\n  border-radius: var(--radius-md);\n  text-align: center;\n}\n\n.edu-create__models-state--error {\n  color: var(--fg-anti-red);\n  border-color: var(--fg-anti-red);\n  background: var(--error-light);\n}\n\n.edu-create__model-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  cursor: pointer;\n  transition: var(--transition-fast);\n  text-align: left;\n  font-family: inherit;\n}\n\n.edu-create__model-card:hover {\n  border-color: var(--fg-side-hover);\n}\n\n.edu-create__model-card--on {\n  background: var(--fg-bg-connected);\n}\n\n.edu-create__model-text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.edu-create__model-name {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.edu-create__model-provider {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  color: var(--fg-text-gray);\n}\n\n.edu-create__model-modality {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  font-size: 11px;\n  font-weight: 600;\n  line-height: 16px;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  border-radius: var(--radius-full);\n  background: var(--fg-bg-card);\n  color: var(--fg-text-gray);\n  border: 1px solid var(--fg-line);\n}\n\n.edu-create__model-modality--chat {\n  background: var(--fg-bg-liteblue);\n  color: var(--fg-text-purple);\n  border-color: transparent;\n}\n\n.edu-create__model-modality--image,\n.edu-create__model-modality--image_gen {\n  background: var(--fg-bg-warm);\n  color: var(--fg-orange-warn);\n  border-color: transparent;\n}\n\n.edu-create__model-modality--embedding {\n  background: var(--fg-bg-cool);\n  color: var(--fg-text-purple);\n  border-color: transparent;\n}\n\n.edu-create__model-modality--stt,\n.edu-create__model-modality--tts {\n  background: var(--fg-bg-cooler);\n  color: var(--fg-text-purple);\n  border-color: transparent;\n}\n\n.edu-create__model-modality--rerank {\n  background: var(--fg-bg-litepp);\n  color: var(--fg-text-purple);\n  border-color: transparent;\n}\n\n.edu-create__footer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px;\n  background: var(--fg-bg-toolbox);\n}\n\n.edu-create__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  min-height: 42px;\n  padding: 6px 12px;\n  border: 0;\n  border-radius: 12px;\n  font-family: inherit;\n  font-size: 16px;\n  font-weight: 700;\n  color: #fff;\n  cursor: pointer;\n  transition: var(--transition-fast);\n  white-space: nowrap;\n}\n\n.edu-create__btn--primary {\n  background: var(--fg-button);\n}\n\n.edu-create__btn--primary:hover {\n  background: var(--fg-button-hover);\n}\n\n.edu-create__btn--cancel {\n  background: var(--fg-text-gray);\n}\n\n.edu-create__btn--cancel:hover {\n  background: #6f6f6f;\n}\n\n@media (max-width: 1440px) {\n  .edu-create__panel {\n    flex: 0 0 560px;\n    width: 560px;\n  }\n}\n\n/* ========================================================================\n   EduCourse — 수강중인 강의 (학습 성과 + 대화 기록 통합)\n   ======================================================================== */\n\n/* 강의 헤더 카드 (Figma 2073:21398) — 단일 행 레이아웃 */\n.edu-course__head-card {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 12px 20px;\n  background: #f8f8f8;\n  border: 0;\n  border-radius: 12px;\n}\n\n/* 1) 뒤로가기 버튼 */\n.edu-course__back {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  padding: 0;\n}\n\n.edu-course__back:hover {\n  color: var(--fg-side-hover);\n}\n\n/* 2) Current Class 그린 알약 (240x58) */\n.edu-course__current-class {\n  flex-shrink: 0;\n  width: 240px;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 10px 12px;\n  background: var(--fg-class-green);\n  border: 0;\n  border-radius: 12px;\n  color: #fff;\n  cursor: pointer;\n  font-family: inherit;\n  text-align: left;\n}\n\n.edu-course__current-class:hover {\n  filter: brightness(0.95);\n}\n\n.edu-course__current-class-icon {\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.edu-course__current-class-text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.edu-course__current-class-meta {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.edu-course__current-class-dday {\n  color: var(--fg-yellow);\n}\n\n.edu-course__current-class-status {\n  color: #f2f2f2;\n}\n\n.edu-course__current-class-title {\n  font-size: 15px;\n  font-weight: 500;\n  color: #fff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.edu-course__current-class-arrow {\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n/* 3) 가운데 — 태그 + 제목 + 설명 (flex 1) */\n.edu-course__head-main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.edu-course__head-title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.edu-course__head-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.edu-course__head-desc {\n  margin: 0;\n  font-size: 13px;\n  line-height: 16px;\n  color: var(--fg-text-gray);\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n/* 4) 우측 통계 — 총 대화 / 학습일 / 기간 / 강사 */\n.edu-course__head-stats {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  flex-shrink: 0;\n}\n\n.edu-course__head-stat {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  white-space: nowrap;\n  color: var(--fg-text-basic);\n}\n\n.edu-course__head-stat em {\n  font-style: normal;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.edu-course__head-stat b {\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.edu-course__head-stat--icon em {\n  font-size: 14px;\n  line-height: 1;\n  color: var(--fg-text-basic);\n}\n\n.edu-course__head-stat-divider {\n  width: 1px;\n  height: 22px;\n  background: var(--fg-line);\n}\n\n.edu-course__head-stat svg {\n  color: var(--fg-text-basic);\n  flex-shrink: 0;\n}\n\n.edu-course__head-avatar {\n  width: 28px;\n  height: 28px;\n  display: inline-grid;\n  place-items: center;\n  background: #bfdbfe;\n  border-radius: 9999px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.edu-course__head-stat strong {\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n/* 5) 강의 상세 보기 버튼 (보라 toolbar 스타일, 32 high) */\n.edu-course__head-detail-btn {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  height: 32px;\n  padding: 5px 7px 7px;\n  background: var(--fg-button);\n  border: 0;\n  border-radius: 4px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: var(--transition-fast);\n}\n\n.edu-course__head-detail-btn:hover {\n  background: var(--fg-button-hover);\n}\n\n.edu-course__head-detail-btn svg {\n  flex-shrink: 0;\n}\n\n@media (max-width: 1280px) {\n  .edu-course__head-card {\n    flex-wrap: wrap;\n  }\n\n  .edu-course__head-stats {\n    flex-wrap: wrap;\n  }\n}\n\n/* 학습 성과 컨테이너 (Figma 2073:21388) */\n.edu-course__progress {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  margin-top: 12px;\n}\n\n.edu-course__section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* 섹션 헤더 — 아이콘 40px + 타이틀/eyebrow 스택 */\n.edu-course__section-head {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin: 0;\n}\n\n.edu-course__section-icon {\n  width: 40px;\n  height: 40px;\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  color: var(--fg-text-basic);\n}\n\n.edu-course__section-icon svg {\n  width: 28px;\n  height: 28px;\n}\n\n.edu-course__section-text {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 0;\n}\n\n.edu-course__section-head h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.edu-course__section-head p {\n  margin: 2px 0 0;\n  font-size: 13px;\n  line-height: 1;\n  color: var(--fg-text-gray);\n}\n\n/* AI 실습 — 3블록 (모델별 사용량 wide + 대화 모드 + 상세 설정 활용) */\n.edu-course__blocks {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr;\n  gap: 20px;\n}\n\n.edu-course__block {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  padding: 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n}\n\n.edu-course__block h4 {\n  margin: 0 0 20px;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n}\n\n/* 모델별 사용량 — 행: 헤더 위에 막대 아래 */\n.edu-course__row-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.edu-course__row-list li {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.edu-course__row-head {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  height: 20px;\n}\n\n.edu-course__row-name {\n  flex: 1;\n  font-size: 12px;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.edu-course__row-count {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.edu-course__row-bar {\n  height: 7px;\n  background: var(--fg-bg-card);\n  overflow: hidden;\n}\n\n.edu-course__row-bar>span {\n  display: block;\n  height: 100%;\n  background: var(--fg-cyan-bar);\n}\n\n/* \"미사용 모델 모두 보기\" 링크 */\n.edu-course__block-footer {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  align-self: center;\n  gap: 4px;\n  margin: 16px 0 0;\n  padding: 4px 8px;\n  background: transparent;\n  border: 0;\n  font-family: inherit;\n  font-size: 12px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.edu-course__block-footer:hover {\n  color: var(--fg-side-hover);\n}\n\n/* 대화 모드 / 상세 설정 활용 — 라벨+값 행 */\n.edu-course__stat-row {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.edu-course__stat-row li {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 40px;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n  border-top: 1px solid var(--fg-line);\n}\n\n.edu-course__stat-row li:first-child {\n  border-top: 0;\n}\n\n.edu-course__stat-row li b {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n  line-height: 1;\n}\n\n/* 지식베이스 학습 — 첫 카드(2단 stat) + 3개 RAG 카드 */\n.edu-course__kb-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 20px;\n}\n\n.edu-course__kb-upload {\n  padding: 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.edu-course__kb-upload-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n}\n\n.edu-course__kb-upload-value {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 4px;\n}\n\n.edu-course__kb-upload-value b {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n  line-height: 1;\n}\n\n.edu-course__kb-upload-value em {\n  font-style: normal;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n}\n\n/* RAG 카드 — 좌측 타이틀+sub 스택, 우측 값+서픽스 */\n.edu-course__kb-rag {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 28px 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n}\n\n.edu-course__kb-rag-text {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.edu-course__kb-rag-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n}\n\n.edu-course__kb-rag-sub {\n  margin: 0;\n  font-size: 12px;\n  color: var(--fg-text-gray);\n  line-height: 1;\n}\n\n.edu-course__kb-rag-value {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n.edu-course__kb-rag-value b {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n  line-height: 1;\n}\n\n.edu-course__kb-rag-value em {\n  font-style: normal;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n}\n\n/* pill row — 4컬럼 (또는 3컬럼) */\n.edu-course__pill-row {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 20px;\n}\n\n.edu-course__pill-row--3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.edu-course__pill-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  height: 66px;\n}\n\n.edu-course__pill-label {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n}\n\n.edu-course__pill-value {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n  line-height: 1;\n}\n\n/* MCP/에이전트 stat — 값 색상을 파란색(--fg-side-hover)으로 */\n.edu-course__pill-row--blue .edu-course__pill-value {\n  color: var(--fg-side-hover);\n}\n\n/* 프롬프트 첫 카드 — 노란 원 + \"1\" + \"개 활용\" */\n.edu-course__pill-card--accent {\n  background: #fff;\n  border-color: var(--fg-line);\n}\n\n.edu-course__pill-circle {\n  width: 23px;\n  height: 23px;\n  border-radius: 9999px;\n  background: var(--fg-yellow);\n  flex-shrink: 0;\n}\n\n.edu-course__pill-card--accent .edu-course__pill-value {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n  margin-left: 4px;\n}\n\n.edu-course__pill-suffix {\n  font-size: 14px;\n  color: var(--fg-text-basic);\n  margin-left: 4px;\n}\n\n/* MCP 카테고리 row — 회색 배경의 wrapper에 라벨 좌측 + 카드 3개 우측 */\n.edu-course__category-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 16px 20px;\n  background: #f8f8f8;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  margin-top: 0;\n}\n\n.edu-course__category-label {\n  font-size: 15px;\n  font-weight: 600;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  flex-shrink: 0;\n  margin-right: auto;\n}\n\n.edu-course__category-cards {\n  display: flex;\n  align-items: stretch;\n  gap: 20px;\n  flex-shrink: 0;\n}\n\n.edu-course__category-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 4px;\n  width: 280px;\n  padding: 8px 12px;\n  background: #fff;\n  border: 0;\n  border-radius: 8px;\n}\n\n.edu-course__category-text {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  min-width: 0;\n}\n\n.edu-course__category-text strong {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n}\n\n.edu-course__category-text span {\n  font-size: 14px;\n  color: var(--fg-text-gray);\n}\n\n.edu-course__category-value {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--fg-side-hover);\n  line-height: 1;\n}\n\n/* MCP 카드 그리드 */\n.edu-course__mcp-grid {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 20px;\n  margin-top: 0;\n}\n\n/* MCP 카드 (Figma 2073:21590) — 화이트 카드 + 토글 + 부제 + 칩 + 회 사용 pill */\n.edu-course__mcp-card {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 16px 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n}\n\n.edu-course__mcp-card-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.edu-course__mcp-card-title {\n  margin: 0;\n  flex: 1;\n  min-width: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n  word-break: keep-all;\n}\n\n.edu-course__mcp-sub {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 400;\n  line-height: 24px;\n  color: var(--fg-text-basic);\n}\n\n.edu-course__mcp-tools {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px;\n}\n\n.edu-course__mcp-tools li {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 6px;\n  background: var(--fg-bg-liteblue);\n  border-radius: 4px;\n  font-size: 12px;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n}\n\n/* \"0 회 사용\" 큰 pill 버튼 */\n.edu-course__mcp-use {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  margin: 0;\n  padding: 8px 12px;\n  background: var(--fg-bg-card);\n  border: 0;\n  border-radius: 8px;\n  width: 100%;\n  text-align: center;\n}\n\n.edu-course__mcp-use b {\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 40px;\n  color: var(--fg-text-basic);\n}\n\n.edu-course__mcp-use em {\n  font-style: normal;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-text-basic);\n  line-height: 1;\n}\n\n/* 에이전트 빌더 — 1 (배포됨/초안) + 6 (3x2 grid) */\n.edu-course__agent-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) minmax(0, 3fr);\n  gap: 20px;\n}\n\n.edu-course__agent-deploy {\n  padding: 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.edu-course__agent-subgrid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  grid-template-rows: repeat(2, auto);\n  gap: 20px;\n}\n\n/* 반응형 */\n@media (max-width: 1440px) {\n  .edu-course__mcp-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 1280px) {\n  .edu-course__blocks {\n    grid-template-columns: 1fr;\n  }\n\n  .edu-course__kb-grid,\n  .edu-course__pill-row,\n  .edu-course__pill-row--3,\n  .edu-course__agent-subgrid,\n  .edu-course__mcp-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .edu-course__agent-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .edu-course__category-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .edu-course__category-cards {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .edu-course__category-card {\n    flex: 1 1 200px;\n    width: auto;\n  }\n}\n\n/* ─── 대화 기록 탭 (Figma 2073:21729) ─── */\n.edu-course__chatlog {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-top: 12px;\n}\n\n/* 툴바: 좌측 탭 + 우측 검색/정렬 */\n.edu-course__chatlog-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  height: 42px;\n}\n\n.edu-course__chatlog-tabs {\n  display: inline-flex;\n  align-items: center;\n}\n\n.edu-course__chatlog-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 3px;\n  padding: 10px;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.edu-course__chatlog-tab:hover {\n  color: var(--fg-side-hover);\n}\n\n.edu-course__chatlog-tab--active {\n  border-bottom-color: var(--fg-text-basic);\n}\n\n.edu-course__chatlog-tab-count {\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n  line-height: 1;\n}\n\n.edu-course__chatlog-controls {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.edu-course__chatlog-search {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  width: 240px;\n  padding: 7px 12px 7px 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 30px;\n}\n\n.edu-course__chatlog-search-input {\n  flex: 1;\n  min-width: 0;\n  border: 0;\n  outline: none;\n  background: transparent;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n}\n\n.edu-course__chatlog-search-input::placeholder {\n  color: var(--fg-text-gray);\n}\n\n.edu-course__chatlog-search>svg {\n  color: var(--fg-text-gray);\n  flex-shrink: 0;\n}\n\n.edu-course__chatlog-sort {\n  display: inline-flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  width: 122px;\n  padding: 8px 8px 8px 16px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 16px;\n  line-height: 26px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n}\n\n.edu-course__chatlog-sort:hover {\n  border-color: var(--fg-side-hover);\n}\n\n/* 리스트 — 상단 2px 구분선, 각 행 80px 고정, 하단 1px 구분선 */\n.edu-course__chatlog-list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  border-top: 2px solid var(--fg-text-basic);\n}\n\n.edu-course__chatlog-item {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  height: 80px;\n  padding: 20px;\n  background: #fff;\n  border-bottom: 1px solid var(--fg-line);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.edu-course__chatlog-item:hover {\n  background: var(--fg-bg-card);\n}\n\n/* 아이콘 박스 — 40x40, 배경 없음, SVG가 직접 색상 표현 (Figma) */\n.edu-course__chatlog-icon {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  color: var(--fg-side-hover);\n}\n\n.edu-course__chatlog-icon--agent {\n  color: var(--fg-class-green);\n}\n\n/* 본문 — 제목 14 Medium + 요약 13 gray */\n.edu-course__chatlog-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.edu-course__chatlog-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.edu-course__chatlog-summary {\n  margin: 0;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* 편집 버튼 (에이전트 행에만) */\n.edu-course__chatlog-edit {\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n  padding: 2px;\n}\n\n.edu-course__chatlog-edit:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n/* 시간 — 90px 고정, 54 Bold + 분전 Regular (gray) */\n.edu-course__chatlog-time {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 90px;\n  flex-shrink: 0;\n  font-size: 14px;\n  color: var(--fg-text-gray);\n  text-align: right;\n  white-space: nowrap;\n}\n\n.edu-course__chatlog-time b {\n  font-weight: 700;\n  color: var(--fg-text-gray);\n}\n\n.edu-course__chatlog-time em {\n  font-style: normal;\n  font-weight: 400;\n}\n\n/* 턴 수 — 90px 고정, 7 Bold + 턴 Medium (BLUE) */\n.edu-course__chatlog-turns {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  width: 90px;\n  flex-shrink: 0;\n  font-size: 14px;\n  color: var(--fg-side-hover);\n  white-space: nowrap;\n}\n\n.edu-course__chatlog-turns b {\n  font-weight: 700;\n}\n\n.edu-course__chatlog-turns em {\n  font-style: normal;\n  font-weight: 500;\n}\n\n/* 우측 화살표 — 28x28 */\n.edu-course__chatlog-arrow {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  color: var(--fg-text-basic);\n}\n\n/* ========================================================================\n   EduEnrolled — 수강중인 강의 (Figma 2073:21357)\n   ======================================================================== */\n\n/* 헤딩 행: H1 + 도움말 + 우측 탭 */\n.edu-enrolled__heading {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.edu-enrolled__heading>.prompt-intro__h1 {\n  flex-shrink: 0;\n}\n\n.edu-enrolled__heading>.prompt-intro__heading-help {\n  margin-right: auto;\n}\n\n/* 우측 탭 네비 (학습 성과 / 학생 / 대화 기록) */\n.edu-enrolled__tabs {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.edu-enrolled__tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 8px 12px;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.edu-enrolled__tab:hover {\n  color: var(--fg-text-basic);\n}\n\n.edu-enrolled__tab--active {\n  color: var(--fg-text-basic);\n  border-bottom-color: var(--fg-text-basic);\n  font-weight: 600;\n}\n\n.edu-enrolled__tab-count {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--fg-text-gray);\n}\n\n.edu-enrolled__tab--active .edu-enrolled__tab-count {\n  color: var(--fg-side-hover);\n  font-weight: 600;\n}\n\n/* 학생 탭 — 검색 toolbar + 테이블 (EduMy 스타일 재사용) */\n.edu-enrolled__students {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  margin-top: 12px;\n}\n\n.edu-enrolled__students-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n/* AI 실습 학습 — block 하단 보조 텍스트 (이내의 모델 모두 보기) */\n.edu-course__block-footer {\n  margin: 8px 0 0;\n  padding-top: 8px;\n  border-top: 1px solid var(--fg-line);\n  font-size: 12px;\n  color: var(--fg-text-gray);\n  text-align: center;\n}\n\n/* ========================================================================\n   EduCourseSteps — 강의 상세 보기 (STEP 목록)\n   ======================================================================== */\n\n.edu-steps__root {\n  background: var(--fg-bg-dark);\n}\n\n.edu-steps__layout {\n  display: flex;\n  background: var(--fg-bg-content);\n  margin: 0 16px;\n  border-radius: 16px 16px 0 0;\n  min-height: calc(100vh - 52px);\n  overflow: hidden;\n  box-shadow: 0 0 6.3px 1px rgba(0, 0, 0, 0.26);\n}\n\n/* 좁은 collapsed 사이드바 */\n.edu-steps__compact-sidebar {\n  width: 60px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 16px 0;\n  background: var(--fg-bg-content);\n  border-right: 1px solid var(--fg-line);\n}\n\n.edu-steps__compact-head {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--fg-line);\n}\n\n.edu-steps__compact-title {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  text-align: center;\n  writing-mode: horizontal-tb;\n  word-break: keep-all;\n  padding: 0 4px;\n}\n\n.edu-steps__compact-icon {\n  width: 36px;\n  height: 36px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.edu-steps__compact-icon:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n/* STEP 목록 패널 */\n.edu-steps__list-panel {\n  width: 240px;\n  flex-shrink: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 12px;\n  background: #fff;\n  border-right: 1px solid var(--fg-line);\n  overflow-y: auto;\n}\n\n.edu-steps__course-pill {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 12px;\n  background: var(--fg-bg-publishing);\n  color: var(--fg-text-publishing);\n  border: 0;\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 12px;\n  font-weight: 500;\n  cursor: pointer;\n  text-align: left;\n  width: 100%;\n}\n\n.edu-steps__course-title {\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.edu-steps__list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  position: relative;\n}\n\n.edu-steps__list::before {\n  content: '';\n  position: absolute;\n  top: 16px;\n  bottom: 16px;\n  left: 8px;\n  width: 1px;\n  background: var(--fg-line);\n}\n\n.edu-steps__item {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 10px 0 10px 0;\n  cursor: pointer;\n  position: relative;\n}\n\n.edu-steps__item-dot {\n  flex-shrink: 0;\n  width: 9px;\n  height: 9px;\n  margin-top: 8px;\n  background: var(--fg-text-basic);\n  border-radius: 9999px;\n  z-index: 1;\n}\n\n.edu-steps__item--active .edu-steps__item-dot {\n  background: var(--fg-button);\n  box-shadow: 0 0 0 3px rgba(151, 140, 202, 0.25);\n}\n\n.edu-steps__item-body {\n  flex: 1;\n  min-width: 0;\n  padding-left: 4px;\n}\n\n.edu-steps__item-pill {\n  display: inline-block;\n  padding: 2px 8px;\n  background: var(--fg-text-basic);\n  color: #fff;\n  border-radius: 9999px;\n  font-size: 10px;\n  font-weight: 700;\n  margin-bottom: 4px;\n}\n\n.edu-steps__item--active .edu-steps__item-pill {\n  background: var(--fg-button);\n}\n\n.edu-steps__item-title {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.edu-steps__item-time {\n  margin: 2px 0 0;\n  font-size: 11px;\n  color: var(--fg-text-gray);\n}\n\n/* 메인 STEP 디테일 */\n.edu-steps__main {\n  flex: 1;\n  min-width: 0;\n  background: #fff;\n  border-radius: 16px 0 0 0;\n  overflow-y: auto;\n}\n\n.edu-steps__detail {\n  padding: 30px 40px;\n}\n\n.edu-steps__detail-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--fg-line);\n}\n\n.edu-steps__detail-step {\n  flex-shrink: 0;\n  width: 64px;\n  height: 64px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: var(--fg-text-basic);\n  color: #fff;\n  border-radius: 12px;\n  font-size: 11px;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.edu-steps__detail-step strong {\n  font-size: 24px;\n  font-weight: 800;\n  margin-top: 2px;\n}\n\n.edu-steps__detail-title {\n  flex: 1;\n  min-width: 0;\n}\n\n.edu-steps__detail-title h2 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.edu-steps__detail-title p {\n  margin: 8px 0 0;\n  font-size: 14px;\n  line-height: 22px;\n  color: var(--fg-text-gray);\n}\n\n/* ========================================================================\n   EduMy — 내 강의 관리 (+ 학생 정보 패널)\n   Figma: 86:9398 (1536px content)\n   ======================================================================== */\n\n.edu-my__content {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  padding: 30px 32px 60px;\n}\n\n/* 차트 → 통계 카드 사이는 피그마(Frame 290 → Frame 301) 12px */\n.edu-my__chart+.edu-my__stat-grid {\n  margin-top: -28px;\n}\n\n/* 상단 탭 (개요 / 공유한 강의 자료) */\n.edu-my__tabs {\n  margin-left: auto;\n}\n\n/* 공유한 강의 자료 빈 상태 placeholder */\n.edu-my__materials-empty {\n  padding: 80px 20px;\n  text-align: center;\n  color: var(--fg-text-gray);\n  font-size: 14px;\n}\n\n.edu-my__materials-empty p {\n  margin: 0;\n}\n\n/* 공유한 강의 자료 (Figma 2073:22370) — 4개 섹션 */\n.edu-my__materials {\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n  margin-top: 4px;\n}\n\n.edu-my__materials-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.edu-my__materials-section h3 {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.edu-my__materials-grid {\n  display: grid;\n  gap: 20px;\n}\n\n.edu-my__materials-grid--2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.edu-my__materials-grid--3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.edu-my__materials-grid--4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n@media (max-width: 1440px) {\n  .edu-my__materials-grid--4 {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 1100px) {\n\n  .edu-my__materials-grid--3,\n  .edu-my__materials-grid--4 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n/* 카드 공통 */\n.edu-my__mat-card {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  padding: 16px 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  transition: var(--transition-fast);\n}\n\n.edu-my__mat-card:hover {\n  border-color: var(--fg-button);\n}\n\n.edu-my__mat-card-head {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.edu-my__mat-card-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n}\n\n.edu-my__mat-card-row .edu-my__mat-card-title {\n  flex: 1;\n  min-width: 0;\n}\n\n/* MCP/에이전트 카드 — 제목+날짜를 좌측 컬럼으로 묶음 */\n.edu-my__mat-card-titleblock {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.edu-my__mat-card-titleblock .edu-my__mat-card-title {\n  white-space: normal;\n}\n\n.edu-my__mat-card-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.edu-my__mat-card-date {\n  margin: 0;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n}\n\n.edu-my__mat-card-subtitle {\n  margin: 0;\n  font-size: 15px;\n  line-height: 24px;\n  color: var(--fg-text-basic);\n}\n\n.edu-my__mat-card-quote {\n  padding: 8px 12px;\n  background: var(--fg-bg-card);\n  border-radius: 8px;\n}\n\n.edu-my__mat-card-quote p {\n  margin: 0;\n  font-size: 14px;\n  line-height: 20px;\n  color: var(--fg-text-gray);\n  display: -webkit-box;\n  -webkit-line-clamp: 4;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.edu-my__mat-card-block {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.edu-my__mat-card-block-label {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n}\n\n/* MCP — 도구 태그 칩 (Figma: bg-liteblue, 4px radius, 6px x-padding) */\n.edu-my__mat-card-tools {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 2px;\n}\n\n.edu-my__mat-card-tools li {\n  display: inline-flex;\n  align-items: center;\n  padding: 4px 6px;\n  background: var(--fg-bg-liteblue);\n  border-radius: 4px;\n  font-size: 12px;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n}\n\n/* 에이전트 카드 — 대화/발행중 큰 액션 버튼 (Figma 2073:22463) */\n.edu-my__mat-card-actionbtns {\n  display: flex;\n  gap: 8px;\n  width: 100%;\n}\n\n.edu-my__mat-card-actionbtn {\n  flex: 1 0 0;\n  min-width: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  padding: 16px 20px;\n  border: 1px solid var(--fg-line);\n  border-radius: 8px;\n  font-family: inherit;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n/* 대화 — 보라톤 배경 (#eaedfb) + 흐린 테두리 */\n.edu-my__mat-card-actionbtn--chat {\n  background: #eaedfb;\n  color: var(--fg-button-hover);\n}\n\n.edu-my__mat-card-actionbtn--chat:hover {\n  background: #dde2f7;\n}\n\n/* 발행중 — 민트 배경 (#c7ffeb) + 동일색 테두리 (실루엣 없음) */\n.edu-my__mat-card-actionbtn--live {\n  background: #c7ffeb;\n  border-color: #c7ffeb;\n  color: var(--fg-text-basic);\n  padding: 14px 20px;\n}\n\n.edu-my__mat-card-actionbtn--live:hover {\n  background: #b3f5dd;\n  border-color: #b3f5dd;\n}\n\n/* 카드 액션 (공유/실행/편집/삭제) */\n.edu-my__mat-card-actions {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 4px;\n  margin-top: auto;\n}\n\n.edu-my__mat-card-icon-btn {\n  position: relative;\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.edu-my__mat-card-icon-btn:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.edu-my__mat-card-icon-btn--danger {\n  color: var(--fg-anti-red);\n}\n\n.edu-my__mat-card-icon-dot {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  width: 5px;\n  height: 5px;\n  background: var(--fg-anti-red);\n  border-radius: 9999px;\n}\n\n/* ── 강의 헤더 카드 (Figma: Frame 251 — 1536x108) ── */\n.edu-my__head {\n  display: grid;\n  grid-template-columns: 28px 240px minmax(0, 644px) auto 112px;\n  align-items: center;\n  gap: 20px;\n  padding: 12px 20px;\n  border-radius: 14px;\n  background: var(--fg-bg-content);\n}\n\n.edu-my__head-back {\n  width: 28px;\n  height: 28px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n}\n\n.edu-my__head-back:hover {\n  color: var(--fg-side-hover);\n}\n\n/* 강의 선택 드롭다운 래퍼 (절대 위치 기준점) */\n.edu-my__head-pill-wrap {\n  position: relative;\n  width: 240px;\n}\n\n/* 피그마 CurrentClass: 진한 초록(#629351) 배경 + 흰색/노란색 텍스트 */\n.edu-my__head-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  width: 240px;\n  height: 58px;\n  padding: 10px 10px 12px;\n  border-radius: 12px;\n  background: var(--fg-class-green);\n  border: 0;\n  font-family: inherit;\n  font-size: 14px;\n  color: #fff;\n  cursor: pointer;\n  text-align: left;\n}\n\n.edu-my__head-pill:hover {\n  filter: brightness(0.95);\n}\n\n/* opened — 더 어두운 클래스 그린 (Figma: --class-color---dark #487737) */\n.edu-my__head-pill--open {\n  background: #487737;\n}\n\n.edu-my__head-pill--open:hover {\n  filter: none;\n}\n\n.edu-my__head-pill-caret {\n  display: inline-grid;\n  place-items: center;\n  flex-shrink: 0;\n  color: #fff;\n  transition: transform var(--transition-fast);\n}\n\n.edu-my__head-pill-caret--up {\n  transform: rotate(180deg);\n}\n\n/* 드롭다운 패널 (피그마 2061:15735 — 240x450, 흰 배경, 그림자) */\n.edu-my__head-dropdown {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  width: 240px;\n  max-height: 450px;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.06);\n  z-index: 40;\n}\n\n/* 개인플랜 카드 */\n.edu-my__head-dropdown-personal {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n  padding: 10px;\n  background: #fff;\n  border: 0;\n  border-radius: 8px;\n  font-family: inherit;\n  cursor: pointer;\n  text-align: left;\n  transition: background var(--transition-fast);\n}\n\n.edu-my__head-dropdown-personal:hover,\n.edu-my__head-dropdown-personal--alt {\n  background: var(--fg-bg-card);\n}\n\n.edu-my__head-dropdown-avatar {\n  display: inline-grid;\n  place-items: center;\n  width: 25px;\n  height: 25px;\n  border-radius: 9999px;\n  background: var(--fg-text-purple);\n  color: #fff;\n  font-size: 12px;\n  font-weight: 600;\n  flex-shrink: 0;\n}\n\n.edu-my__head-dropdown-personal-name {\n  flex: 1;\n  min-width: 0;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.edu-my__head-dropdown-personal-arrow {\n  display: inline-grid;\n  place-items: center;\n  width: 20px;\n  height: 20px;\n  color: var(--fg-text-gray);\n  transform: rotate(-90deg);\n  flex-shrink: 0;\n}\n\n/* 강의 목록 */\n.edu-my__head-dropdown-list {\n  flex: 1;\n  min-height: 0;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  overflow-y: auto;\n}\n\n.edu-my__head-dropdown-item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n  width: 100%;\n  padding: 10px;\n  background: #fff;\n  border: 0;\n  border-radius: 8px;\n  font-family: inherit;\n  cursor: pointer;\n  text-align: left;\n  transition: background var(--transition-fast);\n}\n\n.edu-my__head-dropdown-item:hover {\n  background: var(--fg-bg-card);\n}\n\n.edu-my__head-dropdown-item--alt {\n  background: var(--fg-bg-card);\n}\n\n.edu-my__head-dropdown-row1 {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.edu-my__head-dropdown-dday {\n  color: var(--fg-anti-red);\n}\n\n.edu-my__head-dropdown-end {\n  color: var(--fg-text-gray);\n}\n\n.edu-my__head-dropdown-end--upcoming {\n  color: var(--fg-link);\n}\n\n.edu-my__head-dropdown-msg {\n  padding: 12px 10px;\n  font-size: 13px;\n  color: var(--fg-text-gray);\n  text-align: center;\n}\n\n.edu-my__head-dropdown-msg--error {\n  color: var(--fg-anti-red);\n}\n\n.edu-my__head-dropdown-title {\n  width: 100%;\n  font-size: 15px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  line-height: normal;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.edu-my__head-dropdown-period {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n  font-size: 13px;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n  white-space: nowrap;\n}\n\n.edu-my__head-pill-icon {\n  display: inline-grid;\n  place-items: center;\n  width: 28px;\n  height: 28px;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.edu-my__head-pill-text {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  min-width: 0;\n}\n\n.edu-my__head-pill-row1 {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n/* D-123 — 배지가 아닌 텍스트, 노란색 */\n.edu-my__head-pill .edu-course__pill-dday {\n  background: transparent;\n  color: #ffd900;\n  padding: 0;\n  border-radius: 0;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: normal;\n  line-height: normal;\n}\n\n.edu-my__head-pill-status {\n  font-size: 12px;\n  font-weight: 600;\n  color: #f2f2f2;\n}\n\n.edu-my__head-pill-title {\n  font-size: 15px;\n  font-weight: 500;\n  color: #fff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: normal;\n}\n\n.edu-my__head-pill>svg {\n  flex-shrink: 0;\n  color: #fff;\n}\n\n.edu-my__head-main {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-width: 0;\n  max-width: 644px;\n}\n\n.edu-my__head-title-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.edu-my__head-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n  line-height: 28px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.edu-my__head-desc {\n  margin: 0;\n  font-size: 13px;\n  line-height: 18px;\n  color: var(--fg-text-gray);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.edu-my__head-meta {\n  display: inline-flex;\n  align-items: center;\n  gap: 14px;\n  white-space: nowrap;\n}\n\n.edu-my__head-meta-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n}\n\n.edu-my__head-meta-item svg {\n  color: var(--fg-text-gray);\n  flex-shrink: 0;\n}\n\n.edu-my__head-meta-item b {\n  font-weight: 700;\n}\n\n.edu-my__head-meta-item em {\n  font-style: normal;\n  margin-left: 2px;\n  color: var(--fg-text-gray);\n  font-weight: 500;\n}\n\n.edu-my__head-meta-coin {\n  color: var(--fg-side-hover);\n  font-weight: 700;\n}\n\n.edu-my__head-meta-coin svg {\n  color: var(--fg-side-hover);\n}\n\n.edu-my__head-meta-coin em {\n  color: var(--fg-side-hover);\n  font-weight: 500;\n}\n\n.edu-my__head-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.edu-my__head-action-btn {\n  min-width: 112px;\n  height: 32px;\n  padding: 0 12px;\n  background: var(--fg-button);\n  border: 0;\n  border-radius: 6px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n  cursor: pointer;\n  transition: var(--transition-fast);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  white-space: nowrap;\n}\n\n.edu-my__head-action-btn:hover {\n  background: var(--fg-button-hover);\n}\n\n.edu-my__head-action-btn svg {\n  flex-shrink: 0;\n}\n\n/* ── 강의 동영상 그리드 (Figma: Frame 693) ── */\n.edu-my__videos {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.edu-my__videos-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.edu-my__videos-title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: var(--fg-text-basic);\n}\n\n.edu-my__videos-grid {\n  display: grid;\n  grid-template-columns: repeat(6, minmax(0, 1fr));\n  gap: 20px;\n}\n\n/* 동영상 카드 — 16:9 썸네일, 좌하단 액션, (선택) 우상단 도구 */\n.edu-my__video-card {\n  position: relative;\n  aspect-ratio: 240 / 135;\n  border-radius: 16px;\n  overflow: hidden;\n  border: 0;\n  padding: 10px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  text-align: left;\n  color: #ffffff;\n  cursor: pointer;\n  transition: transform var(--transition-fast), box-shadow var(--transition-fast);\n}\n\n.edu-my__video-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n\n/* MOCK 썸네일 — 톤별 진한 보라/네이비 그라데이션 */\n.edu-my__video-card--navy {\n  background:\n    radial-gradient(120% 80% at 10% 100%, rgba(139, 92, 246, 0.55) 0%, rgba(0, 0, 0, 0) 60%),\n    linear-gradient(135deg, #1e1b4b 0%, #312e81 45%, #4338ca 100%);\n}\n\n.edu-my__video-card--indigo {\n  background:\n    radial-gradient(120% 80% at 90% 100%, rgba(59, 130, 246, 0.55) 0%, rgba(0, 0, 0, 0) 65%),\n    linear-gradient(135deg, #312e81 0%, #4338ca 55%, #1d4ed8 100%);\n}\n\n/* 가운데 타이틀/서브타이틀 오버레이 */\n.edu-my__video-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 14px 16px;\n  text-align: center;\n  pointer-events: none;\n}\n\n.edu-my__video-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 1.25;\n  letter-spacing: -0.2px;\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.55);\n}\n\n.edu-my__video-sub {\n  margin: 4px 0 0;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: rgba(255, 255, 255, 0.92);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n/* 우상단 도구 (편집/제거) */\n.edu-my__video-tools {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  display: inline-flex;\n  gap: 4px;\n  z-index: 2;\n}\n\n.edu-my__video-tool {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: 0;\n  background: #ffffff;\n  color: var(--fg-text-basic);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0 3px 4.5px rgba(0, 0, 0, 0.17);\n  transition: var(--transition-fast);\n}\n\n.edu-my__video-tool:hover {\n  color: var(--fg-button);\n  transform: translateY(-1px);\n}\n\n/* 좌하단 액션 (재생/이미지) */\n.edu-my__video-actions {\n  position: absolute;\n  left: 10px;\n  bottom: 10px;\n  display: inline-flex;\n  gap: 4px;\n  z-index: 2;\n}\n\n.edu-my__video-action {\n  width: 24px;\n  height: 24px;\n  border-radius: 12px;\n  border: 0;\n  background: var(--fg-button-hover);\n  color: #ffffff;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  filter: drop-shadow(0 4px 2.4px rgba(0, 0, 0, 0.39));\n  transition: var(--transition-fast);\n}\n\n.edu-my__video-action:hover {\n  background: var(--fg-button);\n}\n\n/* + 추가 카드 (점선) */\n.edu-my__video-add {\n  aspect-ratio: 240 / 135;\n  border-radius: 16px;\n  border: 1.5px dashed var(--fg-text-gray);\n  background: transparent;\n  color: var(--fg-text-gray);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.edu-my__video-add:hover {\n  border-color: var(--fg-button);\n  color: var(--fg-button);\n  background: var(--fg-bg-litepp);\n}\n\n@media (max-width: 1440px) {\n  .edu-my__videos-grid {\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 1200px) {\n  .edu-my__videos-grid {\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n  }\n}\n\n/* ── 일별 요청량 차트 (Figma: Frame 303) ── */\n.edu-my__chart {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.edu-my__chart-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.edu-my__chart-title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  line-height: 28px;\n}\n\n.edu-my__chart-tabs {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n}\n\n/* 차트 기간 탭 (Figma 2073:22013) — category-tab 패턴 */\n.edu-my__chart-tab {\n  padding: 10px;\n  background: transparent;\n  border: 0;\n  border-bottom: 2px solid transparent;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1;\n  color: var(--fg-text-basic);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.edu-my__chart-tab:hover {\n  color: var(--fg-side-hover);\n}\n\n.edu-my__chart-tab--active {\n  border-bottom-color: var(--fg-text-basic);\n}\n\n.edu-my__chart-refresh {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n}\n\n.edu-my__chart-refresh:hover {\n  background: var(--fg-bg-card);\n  color: var(--fg-text-basic);\n}\n\n.edu-my__chart-body {\n  display: grid;\n  grid-template-columns: 1fr 369px;\n  gap: 20px;\n  align-items: stretch;\n}\n\n/* 차트 바 영역 — Figma 2073:22022 (18개 컬럼, 50px x 226px 영역) */\n.edu-my__chart-bars {\n  position: relative;\n  display: flex;\n  align-items: flex-end;\n  gap: 10px;\n  overflow-x: auto;\n}\n\n.edu-my__chart-col {\n  flex: 0 0 50px;\n  width: 50px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n}\n\n.edu-my__chart-bar-value {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n  color: #7362c2;\n  text-align: center;\n}\n\n.edu-my__chart-bar-track {\n  width: 20px;\n  height: 182px;\n  background: var(--fg-bg-card, #fbfbfb);\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n}\n\n.edu-my__chart-bar-fill {\n  width: 20px;\n  background: #cbd1ef;\n}\n\n.edu-my__chart-bar-label {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 1;\n  color: var(--fg-text-basic);\n  text-align: center;\n  white-space: nowrap;\n}\n\n/* 모델 사용량 카드 (Figma 2073:22114) — 흰 배경 + 회색 테두리 + 4행 (gap 20) */\n.edu-my__chart-rank {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  padding: 20px;\n  background: #fff;\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  align-self: stretch;\n}\n\n.edu-my__chart-rank-row {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.edu-my__chart-rank-head {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  height: 20px;\n  font-size: 12px;\n  color: var(--fg-text-basic);\n}\n\n.edu-my__chart-rank-name {\n  flex: 1;\n  min-width: 0;\n  font-weight: 400;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.edu-my__chart-rank-count {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n}\n\n.edu-my__chart-rank-track {\n  height: 7px;\n  background: var(--fg-bg-card);\n  overflow: hidden;\n}\n\n.edu-my__chart-rank-fill {\n  display: block;\n  height: 100%;\n  background: var(--fg-cyan-bar);\n}\n\n/* ── 강의 내 활동 통계 (Figma: Frame 301 — 3x2)\n   회색 1px 라인 위에 #fbfbfb 셀 6개. 컨테이너에 border + radius. ── */\n.edu-my__stat-grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  grid-template-rows: 56px 52px;\n  gap: 1px;\n  background: var(--fg-line);\n  border: 1px solid var(--fg-line);\n  border-radius: 12px;\n  overflow: hidden;\n}\n\n.edu-my__stat-cell {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px;\n  background: var(--fg-bg-card);\n}\n\n.edu-my__stat-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  flex-shrink: 0;\n  color: var(--fg-text-basic);\n  background: transparent;\n  border: 0;\n}\n\n.edu-my__stat-icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.edu-my__stat-body {\n  display: flex;\n  flex: 1;\n  min-width: 0;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  white-space: nowrap;\n}\n\n.edu-my__stat-label {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n}\n\n.edu-my__stat-metrics {\n  display: inline-flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.edu-my__stat-metric {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 14px;\n  color: var(--fg-text-gray);\n  white-space: nowrap;\n}\n\n.edu-my__stat-metric b {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--fg-class-green);\n  line-height: 1;\n}\n\n.edu-my__stat-metric em {\n  font-style: normal;\n  font-weight: 400;\n  color: var(--fg-text-gray);\n  line-height: 1;\n}\n\n@media (max-width: 1280px) {\n  .edu-my__stat-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    grid-template-rows: auto;\n  }\n}\n\n/* ── 학생 관리 테이블 (Figma: Frame 318) ── */\n.edu-my__students {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.edu-my__students-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.edu-my__students-title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: var(--fg-text-basic);\n  line-height: 28px;\n}\n\n.edu-my__students-search {\n  position: relative;\n  width: 240px;\n}\n\n.edu-my__students-search-input {\n  width: 100%;\n  height: 42px;\n  padding: 0 40px 0 16px;\n  border: 1px solid var(--fg-line);\n  border-radius: 30px;\n  font-size: 13px;\n  color: var(--fg-text-basic);\n  background: #fff;\n  outline: none;\n  font-family: inherit;\n}\n\n.edu-my__students-search-input:focus {\n  border-color: var(--fg-button);\n}\n\n.edu-my__students-search>svg {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--fg-text-gray);\n  pointer-events: none;\n}\n\n.edu-my__students-table {\n  display: flex;\n  flex-direction: column;\n}\n\n.edu-my__students-thead,\n.edu-my__students-row {\n  display: grid;\n  grid-template-columns: 280px 1fr 200px 120px 72px;\n  align-items: center;\n  gap: 40px;\n  padding: 0 20px;\n}\n\n.edu-my__students-thead {\n  height: 57px;\n  border-bottom: 1px solid var(--fg-line);\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-gray);\n}\n\n.edu-my__students-row {\n  height: 64px;\n  border-bottom: 1px solid var(--fg-line);\n  cursor: pointer;\n  font-size: 14px;\n  color: var(--fg-text-basic);\n  transition: var(--transition-fast);\n}\n\n.edu-my__students-row:hover {\n  background: var(--fg-bg-card);\n}\n\n.edu-my__col-student {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.edu-my__avatar-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--fg-text-basic);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.edu-my__col-courses {\n  display: inline-flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 4px 14px;\n  min-width: 0;\n}\n\n.edu-my__col-courses a {\n  font-size: 14px;\n  color: var(--fg-text-basic);\n  text-decoration: underline;\n  text-underline-offset: 2px;\n  white-space: nowrap;\n}\n\n.edu-my__col-courses a:hover {\n  color: var(--fg-side-hover);\n}\n\n.edu-my__col-period {\n  font-size: 14px;\n  color: var(--fg-text-gray);\n  white-space: nowrap;\n}\n\n.edu-my__col-status {\n  display: inline-flex;\n  align-items: center;\n}\n\n.edu-my__col-action {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.edu-my__avatar {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  display: grid;\n  place-items: center;\n  border-radius: 9999px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.edu-my__avatar--lg {\n  width: 64px;\n  height: 64px;\n  font-size: 22px;\n}\n\n/* 상태 pill */\n.edu-my__status-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 12px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n}\n\n.edu-my__status-pill--active {\n  background: #daffd7;\n  color: #3cb832;\n}\n\n.edu-my__status-pill--mine {\n  background: #ffe4b8;\n  color: #ea5440;\n}\n\n.edu-my__status-pill--pending {\n  background: #d0f8ff;\n  color: #3cb6ca;\n}\n\n.edu-my__status-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 9999px;\n  background: currentColor;\n}\n\n.edu-my__row-icon-btn {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: var(--fg-text-gray);\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.edu-my__row-icon-btn:hover {\n  background: var(--fg-bg-card);\n  color: var(--fg-text-basic);\n}\n\n/* 우측 슬라이드 패널 - 회원 정보 (Figma 2073:22889 — 768px wide, 우측 끝에 붙음) */\n.edu-my__panel {\n  position: relative;\n  flex: 0 0 768px;\n  width: 768px;\n  display: flex;\n  flex-direction: column;\n  background: var(--fg-bg-toolbox);\n  color: #fff;\n  box-shadow: -4px 0 3.5px rgba(0, 0, 0, 0.2);\n  border-radius: 0 16px 0 0;\n  animation: agentChatPanelIn 0.18s ease-out;\n}\n\n/* 패널이 열렸을 때 prompt__layout의 우측 16px 여백을 제거하여 패널이 뷰포트 우측 끝에 붙도록 함 */\n.prompt:has(.edu-my__panel) .prompt__layout,\n.prompt:has(.edu-create__panel) .prompt__layout {\n  margin-right: 0;\n}\n\n.edu-my__panel-head {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 20px 20px 0;\n  flex-shrink: 0;\n}\n\n.edu-my__panel-title {\n  flex: 1;\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: #fff;\n}\n\n.edu-my__panel-close {\n  width: 32px;\n  height: 32px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: #fff;\n  cursor: pointer;\n  padding: 2px;\n  transition: var(--transition-fast);\n}\n\n.edu-my__panel-close:hover {\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.edu-my__panel-body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: 20px 20px 90px;\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n}\n\n/* 프로필 */\n.edu-my__panel-profile {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.edu-my__avatar--lg {\n  width: 80px;\n  height: 80px;\n  font-size: 28px;\n  flex-shrink: 0;\n}\n\n.edu-my__panel-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.edu-my__panel-name {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: #fff;\n}\n\n.edu-my__panel-email {\n  margin: 0;\n  font-size: 13px;\n  color: var(--fg-blue-lite);\n  line-height: 20px;\n}\n\n.edu-my__panel-meta {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 14px;\n  color: #fff;\n  line-height: 20px;\n}\n\n.edu-my__panel-meta-divider {\n  width: 1px;\n  height: 12px;\n  background: rgba(255, 255, 255, 0.4);\n}\n\n/* 섹션 */\n.edu-my__panel-section {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.edu-my__panel-section-title {\n  margin: 0;\n  padding: 0;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 28px;\n  color: #fff;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n/* 강의 카드 — 펼침/접힘 공통 wrapper */\n.edu-my__panel-course {\n  display: flex;\n  flex-direction: column;\n}\n\n/* 헤더 행 (접힘 카드 자체이기도 함) */\n.edu-my__panel-course-head {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 16px 16px 16px 20px;\n  background: transparent;\n  border: 1px solid var(--fg-text-gray);\n  border-radius: 12px;\n  cursor: pointer;\n  text-align: left;\n  font-family: inherit;\n  transition: var(--transition-fast);\n  width: 100%;\n}\n\n.edu-my__panel-course-head:hover {\n  border-color: #fff;\n}\n\n/* 펼친 카드 — 헤더는 진한 elev 색상, 흰 테두리, 하단 코너 직각 */\n.edu-my__panel-course--active .edu-my__panel-course-head {\n  background: var(--fg-bg-toolbox-elev);\n  border-color: #fff;\n  border-radius: 12px 12px 0 0;\n}\n\n.edu-my__panel-course-title {\n  flex: 1;\n  min-width: 0;\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.edu-my__panel-dday {\n  flex-shrink: 0;\n  background: transparent;\n  color: var(--fg-orange-warn);\n  padding: 0;\n  border-radius: 0;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 1;\n}\n\n.edu-my__panel-arrow {\n  width: 24px;\n  height: 24px;\n  display: grid;\n  place-items: center;\n  background: transparent;\n  border: 0;\n  color: #fff;\n  cursor: pointer;\n  padding: 2px;\n  flex-shrink: 0;\n  transition: transform 0.2s ease;\n}\n\n.edu-my__panel-course--active .edu-my__panel-arrow {\n  transform: rotate(180deg);\n}\n\n/* 펼친 카드 본문 — 1px gap으로 회색선 효과 */\n.edu-my__panel-course-body {\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n  padding: 0;\n  background: var(--fg-text-gray);\n  border: 1px solid #fff;\n  border-top: 0;\n  border-radius: 0 0 12px 12px;\n  overflow: hidden;\n}\n\n.edu-my__panel-course-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 20px;\n  background: var(--fg-bg-toolbox);\n}\n\n.edu-my__panel-course-row svg {\n  width: 28px;\n  height: 28px;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.edu-my__panel-course-row-label {\n  flex: 1;\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.edu-my__panel-course-row-value {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 4px;\n  white-space: nowrap;\n}\n\n.edu-my__panel-course-row-value b {\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--fg-yellow);\n  line-height: 1;\n}\n\n.edu-my__panel-course-row-value em {\n  font-style: normal;\n  font-size: 14px;\n  font-weight: 400;\n  color: var(--fg-line);\n}\n\n.edu-my__panel-course-row-multi {\n  display: inline-flex;\n  align-items: center;\n  gap: 16px;\n}\n\n/* 상태 pill */\n.edu-my__panel-status-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  padding: 6px 10px;\n  border-radius: 20px;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.edu-my__panel-status-pill .edu-my__panel-status-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 9999px;\n  background: currentColor;\n}\n\n.edu-my__panel-status-pill--active {\n  background: #daffd7;\n  color: #3cb832;\n}\n\n.edu-my__panel-status-pill--mine {\n  background: #ffe4b8;\n  color: #ea5440;\n}\n\n/* \"강의 전체 모두 보기 (12)\" */\n.edu-my__panel-more {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  align-self: center;\n  padding: 8px;\n  background: transparent;\n  border: 0;\n  font-family: inherit;\n  font-size: 12px;\n  color: #fff;\n  cursor: pointer;\n  transition: var(--transition-fast);\n}\n\n.edu-my__panel-more:hover {\n  color: var(--fg-blue-lite);\n}\n\n.edu-my__panel-more svg {\n  flex-shrink: 0;\n}\n\n/* 푸터 — 절대 하단 (edu-create와 동일한 패턴) */\n.edu-my__panel-footer {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 12px;\n  background: var(--fg-bg-toolbox);\n}\n\n.edu-my__panel-btn--danger {\n  background: var(--fg-orange-warn);\n}\n\n.edu-my__panel-btn--danger:hover {\n  background: #e66800;\n}\n\n@media (max-width: 1600px) {\n  .edu-my__panel {\n    flex: 0 0 600px;\n    width: 600px;\n  }\n}\n\n@media (max-width: 1280px) {\n  .edu-my__panel {\n    flex: 0 0 480px;\n    width: 480px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
